<script>

import Utils from '../../common/Utils';
import CommonConstants from '../../common/Constants';
import Service from '@/services/planning';
import { FilterMatchMode, FilterOperator } from 'primevue/api';
import GenericCustomMasterDataAutocompleteV2 from '@/components/generic/GenericCustomMasterDataAutocompleteV2.vue';
export default {
    components: 
        {
            GenericCustomMasterDataAutocompleteV2,
        },
    props: [],
    data() {
        return {                            
            dealNote: {},
            dealNoteDocument: {},
            dealNoteLog: {},
            newDocument: {
                description: ''
            },
            disabledFirstSection: true,
            disabledSecondSection: true,
            disabledThirdSection: true,
            addPriceWindow: {},
            showPriceWindowDialog: false,
            priceWindowType: [],
            priceWindowDateType: [],
            filterCombo: {},
            showUploadDialog: false,
            showDownloadDialog: false,
            showConfirmDialog: false,
            confirmMessage: '',
            showLogDialog: false,
            selectedDeal: null,
            selected: false,
            startDate : Utils.setFirstDayOfMonth(Utils.formatDatePlusMonths(new Date(), -1)),
            //laycanEndDate : Utils.setLastDayOfMonth(new Date()),
            updateMode: false,
            editDataCrude: [],
            statusArray: [
                'SOFT', 'FIRM', 'DONE', 'CANCELLED'
            ],
            terminalArray: [
                'S', 'N'
            ],
            registryPriceWindowTypes: [{value: 1, label: 'ciao'}, {value: 2, label: 'test'}],
            crudeFilters:{
                status: { value: null, matchMode: FilterMatchMode.EQUALS },
                registryProduct: { value: null, matchMode: FilterMatchMode.CONTAINS },
                laycanStartDate: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
                laycanEndDate: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
                grade: { value: null, matchMode: FilterMatchMode.CONTAINS },
                voyageNumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
                registryVessel: { value: null, matchMode: FilterMatchMode.CONTAINS },
                quality: { value: null, matchMode: FilterMatchMode.CONTAINS },
                econs: { value: null, matchMode: FilterMatchMode.CONTAINS },
                marker: { value: null, matchMode: FilterMatchMode.CONTAINS },
                priceWindow: { value: null, matchMode: FilterMatchMode.CONTAINS },
                premium: { value: null, matchMode: FilterMatchMode.CONTAINS },
                dfl: { value: null, matchMode: FilterMatchMode.CONTAINS },
                margin: { value: null, matchMode: FilterMatchMode.CONTAINS },
                buyerSeller: { value: null, matchMode: FilterMatchMode.CONTAINS },
                benchmark: { value: null, matchMode: FilterMatchMode.CONTAINS },
                terminal: { value: null, matchMode: FilterMatchMode.EQUALS },
                code: { value: null, matchMode: FilterMatchMode.CONTAINS },
                isabCode: { value: null, matchMode: FilterMatchMode.CONTAINS }
            },
            dieselFilters:{
                status: { value: null, matchMode: FilterMatchMode.EQUALS },
                registryProduct: { value: null, matchMode: FilterMatchMode.CONTAINS },
                laycanStartDate: { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
                laycanEndDate: { value: null, matchMode: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
                grade: { value: null, matchMode: FilterMatchMode.CONTAINS },
                voyageNumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
                registryVessel: { value: null, matchMode: FilterMatchMode.CONTAINS },
                quality: { value: null, matchMode: FilterMatchMode.CONTAINS },
                econs: { value: null, matchMode: FilterMatchMode.CONTAINS },
                marker: { value: null, matchMode: FilterMatchMode.CONTAINS },
                priceWindow: { value: null, matchMode: FilterMatchMode.CONTAINS },
                premium: { value: null, matchMode: FilterMatchMode.CONTAINS },
                dfl: { value: null, matchMode: FilterMatchMode.CONTAINS },
                margin: { value: null, matchMode: FilterMatchMode.CONTAINS },
                buyerSeller: { value: null, matchMode: FilterMatchMode.CONTAINS },
                benchmark: { value: null, matchMode: FilterMatchMode.CONTAINS },
                terminal: { value: null, matchMode: FilterMatchMode.EQUALS },
                code: { value: null, matchMode: FilterMatchMode.CONTAINS },
                isabCode: { value: null, matchMode: FilterMatchMode.CONTAINS }
            },
            gasolineFilters:{
                status: { value: null, matchMode: FilterMatchMode.EQUALS },
                registryProduct: { value: null, matchMode: FilterMatchMode.CONTAINS },
                laycanStartDate: { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
                laycanEndDate: { value: null, matchMode: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
                grade: { value: null, matchMode: FilterMatchMode.CONTAINS },
                voyageNumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
                registryVessel: { value: null, matchMode: FilterMatchMode.CONTAINS },
                quality: { value: null, matchMode: FilterMatchMode.CONTAINS },
                econs: { value: null, matchMode: FilterMatchMode.CONTAINS },
                marker: { value: null, matchMode: FilterMatchMode.CONTAINS },
                priceWindow: { value: null, matchMode: FilterMatchMode.CONTAINS },
                premium: { value: null, matchMode: FilterMatchMode.CONTAINS },
                dfl: { value: null, matchMode: FilterMatchMode.CONTAINS },
                margin: { value: null, matchMode: FilterMatchMode.CONTAINS },
                buyerSeller: { value: null, matchMode: FilterMatchMode.CONTAINS },
                benchmark: { value: null, matchMode: FilterMatchMode.CONTAINS },
                terminal: { value: null, matchMode: FilterMatchMode.EQUALS },
                code: { value: null, matchMode: FilterMatchMode.CONTAINS },
                isabCode: { value: null, matchMode: FilterMatchMode.CONTAINS }
            },
            otherFilters:{
                status: { value: null, matchMode: FilterMatchMode.EQUALS },
                registryProduct: { value: null, matchMode: FilterMatchMode.CONTAINS },
                laycanStartDate: { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
                laycanEndDate: { value: null, matchMode: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
                grade: { value: null, matchMode: FilterMatchMode.CONTAINS },
                voyageNumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
                registryVessel: { value: null, matchMode: FilterMatchMode.CONTAINS },
                quality: { value: null, matchMode: FilterMatchMode.CONTAINS },
                econs: { value: null, matchMode: FilterMatchMode.CONTAINS },
                marker: { value: null, matchMode: FilterMatchMode.CONTAINS },
                priceWindow: { value: null, matchMode: FilterMatchMode.CONTAINS },
                premium: { value: null, matchMode: FilterMatchMode.CONTAINS },
                dfl: { value: null, matchMode: FilterMatchMode.CONTAINS },
                margin: { value: null, matchMode: FilterMatchMode.CONTAINS },
                buyerSeller: { value: null, matchMode: FilterMatchMode.CONTAINS },
                benchmark: { value: null, matchMode: FilterMatchMode.CONTAINS },
                terminal: { value: null, matchMode: FilterMatchMode.EQUALS },
                code: { value: null, matchMode: FilterMatchMode.CONTAINS },
                isabCode: { value: null, matchMode: FilterMatchMode.CONTAINS }
            },
            logFilters:{
                operationDate: { value: null, matchMode: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
                field: { value: null, matchMode: FilterMatchMode.CONTAINS },
                username: { value: null, matchMode: FilterMatchMode.CONTAINS },
                oldValue: { value: null, matchMode: FilterMatchMode.CONTAINS },
                newValue: { value: null, matchMode: FilterMatchMode.CONTAINS }
            },
            dealNoteSplitWindowVisible: false,
            dealNoteSplit: {
                id: null,
                actualQuantity1: 0,
                actualVolume1: 0,
                idRegistryPriceWindowType1: null,
                monthDate1: null,
                dateFrom1: null,
                dateTo1: null,
                isReferenceDateIncluded1: false,
                priceWindowDescription1: null,

                actualQuantity2: 0,
                actualVolume2: 0,
                idRegistryPriceWindowType2: null,
                monthDate2: null,
                dateFrom2: null,
                dateTo2: null,
                isReferenceDateIncluded2: false,
                priceWindowDescription2: null
            }            
        }
    },
    created() {
        this.$store.dispatch('security/setNavbarTitle', 'dealNote.page_title');
        this.loadDealNote();
    },
    mounted() {
        let cacheFilters = null;
        let cacheData = this.$store.getters['cacheDataStore/getGridCache']('DealNoteGrid');
        if(cacheData){
            cacheFilters = {};
            for(let i = 0; i < cacheData.length; i++){
                let element = cacheData[i];
                cacheFilters[element.property] = element;
                // let k = element.property.charAt(0).toLowerCase() + element.property.slice(1);
                this.filters[element.propName] = element.value;
            }
            if(cacheFilters){
                this.loadDealNote();
            }
        }           
        window.addEventListener('beforeunload', this.handleBeforeUnload);
    },
    beforeUnmount() {
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    },
    computed: {
        constants() {
            return CommonConstants; 
        },
        utils() {
            return Utils;
        },
        uiPermissions() {
            return this.$store.getters['security/uiPermissions'];
        },
        checkSplitEnabled(){

            let qty = parseInt(this.selectedDeal.actualQuantity*1000);
            let vol = parseInt(this.selectedDeal.actualVolume*1000);

            let qty1 = this.dealNoteSplit.actualQuantity1;
            let qty2 = this.dealNoteSplit.actualQuantity2;
            
            let vol1 = this.dealNoteSplit.actualVolume1;
            let vol2 = this.dealNoteSplit.actualVolume2;

            let sumqty = parseInt((qty1+qty2)*1000);
            let sumvol = parseInt((vol1+vol2)*1000);

            console.log('sumqty', sumqty)
            console.log('sumvol', sumvol)

            return (qty != sumqty || vol != sumvol);
        }
    },
    watch:{
        /*'addPriceWindow.monthDate'(){
            this.calculateMonthDateDescription();
        },*/       
    },
    methods: {
        isVoyageEditable(data){
            //return data.status != 'DONE';
            return true;
        },   
        isDealDocumentsEmpty(){
            return Object.keys(this.dealNoteDocument).length === 0
        },   
        isDealLogEmpty(){
            return Object.keys(this.dealNoteLog).length === 0
        },   
        rowClass(data) {
            /*if(data.status == "DONE"){
                return "bg-done";
            }else if (data.status == "FIRM"){
                return "bg-firm";
            }else if (data.status == "CANCELLED"){
                return "bg-deleted";
            }*/

            if(data.vesselSummaryStatus == "DELETED"){
                return "bg-deleted";
            }
        },  
        openUploadDialog(data){
            this.selectedDeal = data;
            this.showUploadDialog = true;
        },
        openDownloadDialog(data){
            this.selectedDeal = data;
            this.getDealNoteFromArchiflow();
        },
        openLogDialog(data){
            this.selectedDeal = data;
            this.getLog();
        },
        cloneDeal(data){
            this.selectedDeal = data;
            this.cloneDealNote();
        },
        checkStatus(data){
            return data.status != 'SOFT' && data.status != "CANCELLED";
        },
        getStatusLabel(status) {
            switch (status) {
                case 'DONE':
                    return 'success';

                case 'FIRM':
                    return 'warning';

                case 'CANCELLED':
                    return 'danger';
                case 'SOFT':
                    return 'info'

                default:
                    return null;
            }
        },
        loadDealNote(){          
            let body = {
                startDate: this.startDate,
            }

            let cacheData = {
                name: 'DealNoteGrid',
                filters: body
            };
            this.$store.dispatch("cacheDataStore/setGridCache", cacheData);
            this.$store.dispatch("generic/setLoading", true);
            Service.getPlanningDealNote(body, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.dealNote = response.data;
                   for(let i = 0; i < this.dealNote.crudeSheet.length; i++){
                        let item = this.dealNote.crudeSheet[i];
                        item.dealDate = item.dealDate ? Utils.dateToCurrentTimeZone(item.dealDate) : null;
                        item.laycanStartDate = item.laycanStartDate ? Utils.dateToCurrentTimeZone(item.laycanStartDate) : null;
                        item.laycanEndDate = item.laycanEndDate ? Utils.dateToCurrentTimeZone(item.laycanEndDate) : null;
                        item.plannedLaycanEndDate = item.plannedLaycanEndDate ? Utils.dateToCurrentTimeZone(item.plannedLaycanEndDate) : null;
                        item.plannedLaycanStartDate = item.plannedLaycanStartDate ? Utils.dateToCurrentTimeZone(item.plannedLaycanStartDate) : null;
                        item.priceWindowMonth = item.priceWindowMonth ? Utils.dateToCurrentTimeZone(item.priceWindowMonth) : null;
                        item.monthDate = item.monthDate ? Utils.dateToCurrentTimeZone(item.monthDate) : null;
                        item.dateFrom = item.dateFrom ? Utils.dateToCurrentTimeZone(item.dateFrom) : null;
                        item.dateTo = item.dateTo ? Utils.dateToCurrentTimeZone(item.dateTo) : null;
                    }
                    for(let i = 0; i < this.dealNote.dieselSheet.length; i++){
                        let item = this.dealNote.dieselSheet[i];
                        item.dealDate = item.dealDate ? Utils.dateToCurrentTimeZone(item.dealDate) : null;
                        item.laycanStartDate = item.laycanStartDate ? Utils.dateToCurrentTimeZone(item.laycanStartDate) : null;
                        item.laycanEndDate = item.laycanEndDate ? Utils.dateToCurrentTimeZone(item.laycanEndDate) : null;
                        item.plannedLaycanEndDate = item.plannedLaycanEndDate ? Utils.dateToCurrentTimeZone(item.plannedLaycanEndDate) : null;
                        item.plannedLaycanStartDate = item.plannedLaycanStartDate ? Utils.dateToCurrentTimeZone(item.plannedLaycanStartDate) : null;
                        item.priceWindowMonth = item.priceWindowMonth ? Utils.dateToCurrentTimeZone(item.priceWindowMonth) : null;
                        item.monthDate = item.monthDate ? Utils.dateToCurrentTimeZone(item.monthDate) : null;
                        item.dateFrom = item.dateFrom ? Utils.dateToCurrentTimeZone(item.dateFrom) : null;
                        item.dateTo = item.dateTo ? Utils.dateToCurrentTimeZone(item.dateTo) : null;
                    }
                    for(let i = 0; i < this.dealNote.gasolineSheet.length; i++){
                        let item = this.dealNote.gasolineSheet[i];
                        item.dealDate = item.dealDate ? Utils.dateToCurrentTimeZone(item.dealDate) : null;
                        item.laycanStartDate = item.laycanStartDate ? Utils.dateToCurrentTimeZone(item.laycanStartDate) : null;
                        item.laycanEndDate = item.laycanEndDate ? Utils.dateToCurrentTimeZone(item.laycanEndDate) : null;
                        item.plannedLaycanEndDate = item.plannedLaycanEndDate ? Utils.dateToCurrentTimeZone(item.plannedLaycanEndDate) : null;
                        item.plannedLaycanStartDate = item.plannedLaycanStartDate ? Utils.dateToCurrentTimeZone(item.plannedLaycanStartDate) : null;
                        item.priceWindowMonth = item.priceWindowMonth ? Utils.dateToCurrentTimeZone(item.priceWindowMonth) : null;
                        item.monthDate = item.monthDate ? Utils.dateToCurrentTimeZone(item.monthDate) : null;
                        item.dateFrom = item.dateFrom ? Utils.dateToCurrentTimeZone(item.dateFrom) : null;
                        item.dateTo = item.dateTo ? Utils.dateToCurrentTimeZone(item.dateTo) : null;
                    }
                    for(let i = 0; i < this.dealNote.otherSheet.length; i++){
                        let item = this.dealNote.otherSheet[i];
                        item.dealDate = item.dealDate ? Utils.dateToCurrentTimeZone(item.dealDate) : null;
                        item.laycanStartDate = item.laycanStartDate ? Utils.dateToCurrentTimeZone(item.laycanStartDate) : null;
                        item.laycanEndDate = item.laycanEndDate ? Utils.dateToCurrentTimeZone(item.laycanEndDate) : null;
                        item.plannedLaycanEndDate = item.plannedLaycanEndDate ? Utils.dateToCurrentTimeZone(item.plannedLaycanEndDate) : null;
                        item.plannedLaycanStartDate = item.plannedLaycanStartDate ? Utils.dateToCurrentTimeZone(item.plannedLaycanStartDate) : null;
                        item.priceWindowMonth = item.priceWindowMonth ? Utils.dateToCurrentTimeZone(item.priceWindowMonth) : null;
                        item.monthDate = item.monthDate ? Utils.dateToCurrentTimeZone(item.monthDate) : null;
                        item.dateFrom = item.dateFrom ? Utils.dateToCurrentTimeZone(item.dateFrom) : null;
                        item.dateTo = item.dateTo ? Utils.dateToCurrentTimeZone(item.dateTo) : null;
                    }
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        getDealNoteFromArchiflow(){                     
            this.$store.dispatch("generic/setLoading", true);
            Service.getDealNoteFromArchiflow(this.selectedDeal.id, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.showDownloadDialog = true;
                    this.dealNoteDocument = response.data;               
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        getLog(){                    
            this.$store.dispatch("generic/setLoading", true);
            Service.getDealNoteLog(this.selectedDeal.id, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.showLogDialog = true;
                    this.dealNoteLog = response.data;               
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        cloneDealNote(){
            
            if(this.selectedDeal.actualQuantity){
                this.dealNoteSplit = {
                    id: this.selectedDeal.id,
                    actualQuantity1: 0,
                    actualVolume1: 0,
                    idRegistryPriceWindowType1: null,
                    monthDate1: null,
                    dateFrom1: null,
                    dateTo1: null,
                    isReferenceDateIncluded1: false,
                    priceWindowDescription1: null,

                    actualQuantity2: 0,
                    actualVolume2: 0,
                    idRegistryPriceWindowType2: null,
                    monthDate2: null,
                    dateFrom2: null,
                    dateTo2: null,
                    isReferenceDateIncluded2: false,
                    priceWindowDescription2: null
                };

                this.dealNoteSplitWindowVisible = true;
            }else{
                this.$confirm.require({
                    message: this.$t('messages.clone_deal'),
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: this.$t('yes'),
                    rejectLabel: this.$t('no'),
                    accept: () => {
                        let body = {
                            id: this.selectedDeal.id
                        };

                        Service.cloneDealNote(body, ({success, message}) => {
                        if(success){
                            this.loadDealNote();
                            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
                        } else{
                            this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                        }
                        })
                    },
                    reject: () => {
                    this.$confirm.close();
                    }
                });
            }
        },
        performSplitDealNote(){
            let body = {...this.dealNoteSplit};
            Service.splitDealNote(body, ({success, message}) => {
            if(success){
                this.dealNoteSplitWindowVisible = false;
                this.loadDealNote();
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
            } else{
                this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
            }
            })
        },
        exportExcelDealNote(){          
            let body = {
                startDate: this.startDate,
            }

            this.$store.dispatch("generic/setLoading", true);
            let fileNameWithExtension = "DealNote.xlsx";
            Service.exportPlanningDealNote(body, ({success, data, message}) => {
                this.$store.dispatch("generic/setLoading", false);
        
                if(success){
                    var fileURL = window.URL.createObjectURL(new Blob([data]));
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', fileNameWithExtension);
                    document.body.appendChild(fileLink);
                
                    fileLink.click();
                } else{
                    this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            })
        },

        checkPriceWindow(data){
            console.log('checkPriceWindow')
            this.priceWindowValidation = "";

            if(data.idPriceWindow != null && data.idPriceWindow != ""){
                if(data.priceWindowMonth == null){
                    this.priceWindowValidation = "p-invalid-priceWindow";
                    return false;
                }
            }else if(data.priceWindowMonth != null){
                if(data.idPriceWindow == null || data.idPriceWindow == ""){
                    this.priceWindowValidation = "p-invalid-priceWindowMonth";
                    return false;
                }
            }
            return true;
        },

        onCrudeRowEditSave(data){   
            if(data.newData.isReferenceDateIncluded == undefined || data.newData.isReferenceDateIncluded == null){
                data.newData.isReferenceDateIncluded = false;
            }   

            if(data.data.status == "DONE"){
                this.$confirm.require({
                    message: this.$t('dealNote.updateStatusDoneMessage'),
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: this.$t('yes'),
                    rejectLabel: this.$t('no'),
                    accept: () => {
                        this.$store.dispatch("generic/setLoading", true);
                        Service.updatePlanningDealNote(data.newData, response => {
                            this.$store.dispatch("generic/setLoading", false);
                            if(response.success){
                                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                                this.loadDealNote();
                            }else{
                                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:5000, severity:'error'});
                            }
                        })
                    }
                })
            }else{          
                this.$store.dispatch("generic/setLoading", true);
                Service.updatePlanningDealNote(data.newData, response => {
                    this.$store.dispatch("generic/setLoading", false);
                    if(response.success){
                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                        this.loadDealNote();
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:5000, severity:'error'});
                    }
                })
            }                     
        },
        vesselSummaryCancelled(data){
            return data.status != "CANCELLED" && data.vesselSummaryStatus == "DELETED"; 
        },
        uploaderResponseMethod(file){
            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result.split(',')[1]);
                reader.onerror = reject;
            });
            file.files.forEach( async (document) => {
                const base64 = await toBase64(document);

                let formData = {
                    idDealNote: this.selectedDeal.id,               
                    fileNameWithExtension: document.name,
                    fileContentBase64: base64,
                    documentType: 'Deal Note',
                    description: this.newDocument.description 
                }
                this.$store.dispatch("generic/setLoading", true);
    
                this.lastLoaded = null;
                Service.uploadPlanningDealNote(formData, ({success, data, message}) => {
                    this.$store.dispatch("generic/setLoading", false);
                    this.newDocument.type = '';
                    this.newDocument.description = '';

                    if(success){
                        this.showUploadDialog = false;
                        this.$toast.add({detail: this.$t('messages.upload_message_success'), life:3000, severity:'success'});
                    }else{
                        this.$toast.add({ detail: message && message != '' ? message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                    }
                })
            })  
        },
        downloadDocument({documentGuid, fileName, fileExtension}){
        this.$store.dispatch("generic/setLoading", true);
        let fileNameWithExtension = fileName + fileExtension;
        Service.downloadDocumentDealNote({documentGuid: documentGuid, fileNameWithExtension }, ({success, data, message}) => {
            this.$store.dispatch("generic/setLoading", false);
            
            if(success){
            var fileURL = window.URL.createObjectURL(new Blob([data]));
            var fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.setAttribute('download', fileNameWithExtension);
            document.body.appendChild(fileLink);
        
            fileLink.click();
            } else{
            this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
            }
        })
        },
        deleteDocument({documentGuid}){
            this.$confirm.require({
                message: this.$t('messages.delete_message_question'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    
                    Service.deleteDealNoteFromArchiflow(documentGuid, ({success, message}) => {
                    if(success){
                        this.getDealNoteFromArchiflow();
                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000});
                    } else{
                        this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                    }
                    })
                },
                reject: () => {
                    this.$confirm.close();
                }
            });
        },
        openPriceWindowDialog(){            
            this.addPriceWindow = {};
            this.disabledFirstSection = true;
            this.disabledSecondSection = true;
            this.disabledThirdSection = true;

            this.showPriceWindowDialog = true;

            let body  = {}

            Service.getDealNotePriceWindowType(body, response => {
                if(response.success && response.data != null){
                    this.priceWindowType = response.data;
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })

            Service.getDealNotePriceWindowDateType(body, response => {
                if(response.success && response.data != null){
                    this.priceWindowDateType = response.data;
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        setFilter(data){
            this.filterCombo = {
                family: data.family,
                columnType: "Grade"
            }

            return this.filterCombo;
        },
        handleBeforeUnload(event) {  
            if(this.editDataCrude.length > 0){
                const message = this.$t('dealNote.exitMessage');
                event.returnValue = message;
                return message;  
            }                     
        },
        managePriceWindowSection(disabledFirstSection, disabledSecondSection, disabledThirdSection){
            this.addPriceWindow = {};

            this.addPriceWindow.isReferenceDateIncluded = false;

            if(!disabledFirstSection){
                this.disabledFirstSection = false;
                this.disabledSecondSection = true;
                this.disabledThirdSection = true;

                for(let i = 0; i < this.priceWindowType.length; i++){
                    let item = this.priceWindowType[i];

                    if(item.description == 'Full Month'){
                        this.addPriceWindow.idRegistryPriceWindowType = item.id;
                    }
                }


            }else if(!disabledSecondSection){
                this.disabledFirstSection = true;
                this.disabledSecondSection = false;
                this.disabledThirdSection = true;

                for(let i = 0; i < this.priceWindowType.length; i++){
                    let item = this.priceWindowType[i];

                    if(item.description == 'Date Range'){
                        this.addPriceWindow.idRegistryPriceWindowType = item.id;
                    }
                }
                
            }else{
                this.disabledFirstSection = true;
                this.disabledSecondSection = true;
                this.disabledThirdSection = false;

                for(let i = 0; i < this.priceWindowType.length; i++){
                    let item = this.priceWindowType[i];

                    if(item.description == 'Specific Date'){
                        this.addPriceWindow.idRegistryPriceWindowType = item.id;
                    }
                }
            }
        },
        onUpdatePriceWindow(priceWindow, data){
            switch(priceWindow.value){
                case 2:
                    data.dateFrom = data.laycanEndDate;
                break;
                case 3:
                    data.dateFrom = data.laycanEndDate;
                break;
                case 4:
                    data.dateFrom = data.laycanEndDate;
                break;

                case 5: {
                    data.isReferenceDateIncluded = false;
                    break;
                }

                case 1:
                default: {
                    data.dateFrom = null;
                    data.isReferenceDateIncluded = false;
                }
                break;
            }
        }
    },
    beforeRouteLeave(to, from, next) {
      if(this.editDataCrude.length > 0){
        this.$confirm.require({
            message: this.$t('dealNote.exitMessage'),
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: this.$t('yes'),
            rejectLabel: this.$t('no'),
            accept: () => {
                this.nextRoute = next;
                window.removeEventListener('beforeunload', this.handleBeforeUnload);
                this.nextRoute();
            },
            reject: () => {
                this.$confirm.close();
            }
        });
      }else{
        this.nextRoute = next;
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
        this.nextRoute();
      }
    }
}
</script>

<template>
    <main>
        <Dialog v-model:visible="dealNoteSplitWindowVisible" :style="{ width: '600px' }" modal header="Split Deal Note">            
           <p>{{ $t('dealNote.splitMessage1') }}<b>{{utils.formatDecimal(selectedDeal.actualQuantity, 3, "it-IT")}} MT</b>{{ $t('dealNote.splitMessage2') }}<b>{{ utils.formatDecimal(selectedDeal.actualVolume, 3, "it-IT") }} m3</b>{{ $t('dealNote.splitMessage3') }}<b>{{ selectedDeal.priceWindow }}</b></p>

            <div class="grid">
                <div class="col-6">
                    <div class="grid">
                        <div class="col-12">
                            <label for="actualQuantity1">{{ $t('dealNote.actualQuantity1') }}</label>
                            <InputNumber v-model="dealNoteSplit.actualQuantity1" class="w-full" :minFractionDigits="3" :maxFractionDigits="3" />
                        </div>
                        <div class="col-12">
                            <label for="actualVolume1">{{ $t('dealNote.actualVolume1') }}</label>
                            <InputNumber v-model="dealNoteSplit.actualVolume1" class="w-full" :minFractionDigits="3" :maxFractionDigits="3" />
                        </div>
                        <div class="col-12">
                            <label>{{ $t("dealNote.labelPriceWindow") }}</label>
                            <GenericCustomMasterDataAutocompleteV2
                                class="w-full"
                                name= "planning/deal-note-price-window-combo"
                                v-model="dealNoteSplit.idRegistryPriceWindowType1"
                                :refLabel="dealNoteSplit"
                                :api="`masterdata/price-window-type-combo`"/> 
                                <!-- :changeFn="onUpdatePriceWindowSplit" -->
                                
                        </div>

                        <div class="col-12" v-if="dealNoteSplit.idRegistryPriceWindowType1 == 1">
                            <label>{{ $t("dealNote.labelDatePriceWindow") }}</label>
                            <Calendar
                                class="p-inputtext-sm w-full"
                                placeholder="__/__/____"
                                v-model="dealNoteSplit.monthDate1"
                                dateFormat="mm/yy" :showTime="false"
                                :showIcon="true" :showButtonBar="true" :yearNavigator="true" 
                                view="month" />
                        </div>
                        <div class="col-12" v-else-if="dealNoteSplit.idRegistryPriceWindowType1 == 5">
                            <div class="grid">
                                <div class="col-12 lg:col-6 w-full">
                                    <label>{{ $t("from") }}</label>
                                    <Calendar
                                        class="p-inputtext-sm w-full"
                                        placeholder="__/__/____"
                                        v-model="dealNoteSplit.dateFrom1"
                                        dateFormat="dd/mm/yy" :showTime="false"
                                        :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                                </div>
                                <div class="col-12 lg:col-6 w-full">
                                    <label>{{ $t("to") }}</label>
                                    <Calendar
                                        class="p-inputtext-sm w-full"
                                        placeholder="__/__/____"
                                        v-model="dealNoteSplit.dateTo1"
                                        dateFormat="dd/mm/yy" :showTime="false"
                                        :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                                </div>
                            </div>                                                
                        </div>
                        <div class="col-12" v-else-if="dealNoteSplit.idRegistryPriceWindowType1">
                            <div class="grid">
                                <div class="col-12 lg:col-8">
                                    <label>{{ $t("from") }}</label>
                                    <Calendar
                                        class="p-inputtext-sm w-full"
                                        placeholder="__/__/____"
                                        v-model="dealNoteSplit.dateFrom1"
                                        dateFormat="dd/mm/yy" :showTime="false"
                                        :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                                </div>

                                <div class="col-12 lg:col-4">
                                    <label>{{ $t("Include") }}</label>
                                    <Checkbox class="my-1 w-full" v-model="dealNoteSplit.isReferenceDateIncluded1" :binary="true" /> 
                                </div>                                                          
                            </div>                                                                                                                                            
                        </div> 

                    </div>
                </div>
                <div class="col-6">
                    <div class="grid">
                        <div class="col-12">
                            <label for="actualQuantity2">{{ $t('dealNote.actualQuantity2') }}</label>
                            <InputNumber v-model="dealNoteSplit.actualQuantity2" class="w-full" :minFractionDigits="3" :maxFractionDigits="3" />
                        </div>
                        <div class="col-12">
                            <label for="actualVolume2">{{ $t('dealNote.actualVolume2') }}</label>
                            <InputNumber v-model="dealNoteSplit.actualVolume2" class="w-full" :minFractionDigits="3" :maxFractionDigits="3" />
                        </div>

                        <div class="col-12">
                            <label>{{ $t("dealNote.labelPriceWindow") }}</label>
                            <GenericCustomMasterDataAutocompleteV2
                                class="w-full"
                                name= "planning/deal-note-price-window-combo"
                                v-model="dealNoteSplit.idRegistryPriceWindowType2"
                                :refLabel="dealNoteSplit"
                                :api="`masterdata/price-window-type-combo`"/> 
                                <!-- :changeFn="onUpdatePriceWindowSplit" -->
                                
                        </div>

                        <div class="col-12" v-if="dealNoteSplit.idRegistryPriceWindowType2 == 1">
                            <label>{{ $t("dealNote.labelDatePriceWindow") }}</label>
                            <Calendar
                                class="p-inputtext-sm w-full"
                                placeholder="__/__/____"
                                v-model="dealNoteSplit.monthDate2"
                                dateFormat="mm/yy" :showTime="false"
                                :showIcon="true" :showButtonBar="true" :yearNavigator="true" 
                                view="month" />
                        </div>
                        <div class="col-12" v-else-if="dealNoteSplit.idRegistryPriceWindowType2 == 5">
                            <div class="grid">
                                <div class="col-12 lg:col-6 w-full">
                                    <label>{{ $t("from") }}</label>
                                    <Calendar
                                        class="p-inputtext-sm w-full"
                                        placeholder="__/__/____"
                                        v-model="dealNoteSplit.dateFrom2"
                                        dateFormat="dd/mm/yy" :showTime="false"
                                        :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                                </div>
                                <div class="col-12 lg:col-6 w-full">
                                    <label>{{ $t("to") }}</label>
                                    <Calendar
                                        class="p-inputtext-sm w-full"
                                        placeholder="__/__/____"
                                        v-model="dealNoteSplit.dateTo2"
                                        dateFormat="dd/mm/yy" :showTime="false"
                                        :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                                </div>
                            </div>                                                
                        </div>
                        <div class="col-12" v-else-if="dealNoteSplit.idRegistryPriceWindowType2">
                            <div class="grid">
                                <div class="col-12 lg:col-8">
                                    <label>{{ $t("from") }}</label>
                                    <Calendar
                                        class="p-inputtext-sm w-full"
                                        placeholder="__/__/____"
                                        v-model="dealNoteSplit.dateFrom2"
                                        dateFormat="dd/mm/yy" :showTime="false"
                                        :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                                </div>

                                <div class="col-12 lg:col-4">
                                    <label>{{ $t("Include") }}</label>
                                    <Checkbox class="my-1 w-full" v-model="dealNoteSplit.isReferenceDateIncluded2" :binary="true" /> 
                                </div>                                                          
                            </div>                                                                                                                                            
                        </div> 
                    </div>
                </div>
            
           </div>
           <template #footer>
                <Button label="Cancel" text severity="secondary" @click="dealNoteSplitWindowVisible = false" autofocus />
                <Button :disabled="checkSplitEnabled" :label="$t('btn.save')" icon="fa-solid fa-save" outlined severity="secondary" @click="performSplitDealNote" autofocus />
            </template>
        </Dialog>

        <Dialog v-model:visible="showUploadDialog" :style="{ width: '400px' }" modal header="Upload Deal Note">            
            <span class="text-surface-600 dark:text-surface-0/70 block mb-5">{{ $t("dealNote.description") }}</span>
            <div class="col-12">
                <Textarea autoResize class="w-full" v-model="this.newDocument.description" />
            </div>               
            <div class="col-12">
                <FileUpload name="uploaded[]" :customUpload="true" @uploader="uploaderResponseMethod" :previewWidth="0" :fileLimit="1" :multiple="false" />      
            </div>          
        </Dialog>

        <Dialog v-model:visible="showDownloadDialog" :style="{ width: '900px' }" modal :header="$t('dealNote.documents')">            
            <DataTable showGridlines :value="dealNoteDocument" tableStyle="min-width: 50rem" v-if="isDealDocumentsEmpty() == false">                             
                <Column field="fileName" :header="$t('dealNote.fileName')" style="width: 100px;"></Column>
                <Column field="fileExtension" :header="$t('dealNote.fileExtension')" style="width: 100px;"></Column>
                <Column field="description" :header="$t('dealNote.description')" style="width: 150px;"></Column>
                <Column field="createdBy" :header="$t('dealNote.createdBy')" style="width: 100px;"></Column>
                <Column field="documentDate" :header="$t('dealNote.documentDate')">
                    <template #body="{data, field}">
                        <span> {{data[field] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data[field])) : null}} </span>
                    </template>
                </Column>
                <Column field="documentGuid" headerStyle="width:4rem">
                    <template #body="slotProps">
                        <Button icon="pi pi-download" :label="$t('btn.download')" @click="downloadDocument(slotProps.data)" v-if="slotProps.data.documentGuid" />                  
                    </template>
                </Column>
                <Column field="documentGuid" headerStyle="width:4rem">
                    <template #body="slotProps">                        
                        <Button icon="pi pi-trash" class="p-button-danger" :label="$t('btn.delete')" @click="deleteDocument(slotProps.data)" v-if="slotProps.data.documentGuid" />
                    </template>
                </Column>
            </DataTable>     
            <span v-else>{{ $t('dealNote.warning') }}</span>             
        </Dialog>

        <Dialog v-model:visible="showLogDialog" :style="{ width: '1000px' }" modal :header="$t('dealNote.log')">            
            <DataTable showGridlines :value="dealNoteLog" tableStyle="min-width: 50rem" v-if="isDealLogEmpty() == false" 
            v-model:filters="logFilters" filterDisplay="row" dataKey="id">
                <Column field="operationDate" :header="$t('dealNote.operationDate')" style="width: 250px;">
                    <template #filter="{ filterModel, filterCallback }">
                        <Calendar v-model="filterModel.value" dateFormat="dd/mm/yy" placeholder="dd/mm/yyyy" mask="99/99/9999" @keydown.enter="filterCallback()"/>
                    </template>
                    <template #body="{data, field}">
                        <span> {{data[field] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data[field])) : null}} </span>
                    </template>
                </Column>   
                <Column field="username" :header="$t('dealNote.username')" style="width: 250px;">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                    </template>
                </Column>                          
                <Column field="field" :header="$t('dealNote.field')" style="width: 250px;">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                    </template>
                </Column>
                <Column field="oldValue" :header="$t('dealNote.oldValue')" style="width: 250px;">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                    </template>
                </Column>
                <Column field="newValue" :header="$t('dealNote.newValue')" style="width: 250px;">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                    </template>
                </Column>            
            </DataTable>   
            <span v-else>{{ $t('dealNote.logWarning') }}</span>                        
        </Dialog>       
       
        <div class="grid" style="margin-left: 1%">
            <div class="col-12 lg:col-2 md:col-6">
                <label for="startDate">{{ $t('dealNote.startDate') }}</label>
                <Calendar
                    class="p-inputtext-sm w-full"
                    placeholder="__/__/____"
                    v-model="this.startDate"
                    name="startDate" dateFormat="dd/mm/yy" :showTime="false"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
            </div>
            <!--
            <div class="col-12 lg:col-2 md:col-6">
                <label for="laycanEndDate">{{ $t('dealNote.laycanEndDate') }}</label>
                <Calendar
                    class="p-inputtext-sm w-full"
                    placeholder="__/__/____"
                    v-model="this.laycanEndDate"
                    name="laycanEndDate" dateFormat="dd/mm/yy" :showTime="false"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
            </div> -->
            <div class="col-12 lg:col-4 mt-2">
                <Button type="button" icon="pi pi-replay" class="p-button-sm mx-2 my-3" :label="$t('dealNote.load')" severity="secondary" @click="loadDealNote" />
                <Button v-tooltip="$t('dealNote.exportTooltip')" type="button" icon="pi pi-file-excel" class="p-button-sm p-button-outlined mx-2 my-3" style="color: green" :label="$t('dealNote.export')" @click="exportExcelDealNote" />              
            </div>         
        </div>
        
        <div class="col-12 data">
            <TabView>
                <TabPanel header="Crude">
                    <div class="grid">
                        <div class="col-12" style="height: calc(75vh)" >
                            <DataTable showGridlines :value="dealNote.crudeSheet" scrollable :responsiveLayout="'stack'" scrollHeight="flex" rowGroupMode="subheader" groupRowsBy="family" sortMode="single"
                                :sortOrder="1" editMode="row" size="small" v-model:editing-rows="editDataCrude" @row-edit-save="onCrudeRowEditSave" 
                                dataKey="id" v-model:filters="crudeFilters" filterDisplay="row" :rowClass="rowClass" >
                                
                                    <Column frozen style="width: 180px;" class="button-column over-z" :exportable="false" :reorderableColumn="false">
                                        <template #body="slotProps">
                                            <Button v-tooltip="$t('dealNote.uploadDocument')" icon="fa-solid fa-upload" class="p-button-sm p-button-rounded p-button-outlined mr-1 mb-1" 
                                            size="small" @click="openUploadDialog(slotProps.data)" v-if="!uiPermissions('dealNoteUploadDocument').isHidden" />
                                            <Button v-tooltip="$t('dealNote.downloadDocument')" icon="fa-solid fa-download" class="p-button-sm p-button-rounded p-button-outlined mr-1 mb-1" 
                                            size="small" @click="openDownloadDialog(slotProps.data)" />
                                            <Button v-tooltip="$t('dealNote.openLog')" icon="fa-solid fa-file-lines" class="p-button-sm p-button-rounded p-button-outlined mr-1 mb-1" size="small" @click="openLogDialog(slotProps.data)" />
                                            <Button v-tooltip="$t('dealNote.clone')" icon="fa-solid fa-code-merge" class="p-button-sm p-button-rounded p-button-outlined mr-1 mb-1" size="small" 
                                            @click="cloneDeal(slotProps.data)" v-if="!uiPermissions('dealNoteCloneButton').isHidden" />
                                            <span class="warning" v-if="slotProps.data.isUpdateBlocked" v-tooltip="$t('dealNote.updateBlocked')">
                                                <i class="fas fa-lock" style='font-size:10px; color:black;' />
                                            </span>
                                        </template>
                                    </Column>
                                    
                                    <Column frozen  :rowEditor="true" style="width: 150px;" class="over-z" v-if="!uiPermissions('dealNoteEditButton').isHidden" />

                                    <Column field="family" :header="$t('dealNote.family')">
                                        <template #body="{ data, field }">
                                            <span>
                                                {{ data[field] }}
                                                <Tag severity="warning" value="Modified" v-if="data[field + '_dirty']" />
                                            </span>
                                        </template>
                                    </Column>
                                                        
                                    <Column field="dealDate" :header="$t('dealNote.dealDate')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{data[field] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                                        </template>
                                        <template #editor="{ data, field }">   
                                            <Calendar 
                                                class="w-full" 
                                                v-model="data[field]" 
                                                dateFormat="dd/mm/yy" 
                                                placeholder="dd/mm/yyyy" v-if="isVoyageEditable(data)" />
                                                <span v-else> {{data[field] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data[field])) : null}} </span>                                 
                                        </template>                       
                                    </Column>

                                    <Column field="voyageNumber" :header="$t('dealNote.voyageNumber')" style="width: 150px;"> 
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search"/>
                                        </template>                           
                                    </Column>

                                    <Column field="code" :header="$t('dealNote.code')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                                        </template>
                                    </Column>

                                    <Column field="registryProduct" :header="$t('dealNote.product')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                                        </template>
                                        <template #body="{ data, field }">
                                            <span>{{ data[field] }}</span>
                                            <span class="warning" v-if="checkStatus(data) && data[field] != data.plannedRegistryProduct" v-tooltip="'Planned: ' + data.plannedRegistryProduct">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                        <template #editor="{ data}">
                                            <GenericCustomMasterDataAutocompleteV2
                                                class="p-inputtext-sm w-full"
                                                v-model="data.idRegistryProduct"
                                                api="masterdata/product-combo" 
                                                name="masterdata-product-combo" 
                                                v-if="isVoyageEditable(data)"/> 
                                            <span v-else>{{ data.registryProduct }}</span>                                 
                                        </template>
                                    </Column>

                                    <Column field="grade" :header="$t('dealNote.grade')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                                        </template>
                                        <template #editor="{ data, field }">
                                            <InputText v-model="data[field]" class="w-full" />
                                            <!-- <GenericCustomMasterDataAutocompleteV2
                                                class="w-full"
                                                :name="`registry-deal-note-column-combo?family=${data.family}&columnType=${field}`"
                                                v-model="data[field]"
                                                :api="`masterdata/registry-deal-note-column-combo?family=${data.family}&columnType=${field}`"/>                             -->
                                        </template>
                                    </Column>

                                    <Column field="isabCode" :header="$t('dealNote.isabCode')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                                        </template>
                                    </Column>

                                    <Column field="terminal" :header="$t('dealNote.terminal')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <Dropdown v-model="filterModel.value" :options="terminalArray" 
                                            @change="filterCallback()" class="w-full" placeholder="Terminal" />
                                        </template>
                                        <template #body="{ data, field }">
                                            <span>{{ data[field] }}</span>
                                            <span class="warning" v-if="checkStatus(data) && data[field] != data.plannedTerminal" v-tooltip="'Planned: ' + data.plannedTerminal">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                        <template #editor="{data}">
                                            <GenericCustomMasterDataAutocompleteV2 
                                                class="p-inputtext-sm w-full"
                                                v-model="data.idRegistryPlant"
                                                api="masterdata/registry-plant-combo" 
                                                name="masterdata-registry-plant-combo" 
                                                v-if="isVoyageEditable(data)" />    
                                                <span v-else>{{ data.terminal }}</span>                            
                                        </template>
                                    </Column>

                                    <Column field="registryVessel" :header="$t('dealNote.registryVessel')" style="width: 150px;">                                                              
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search"/>
                                        </template>
                                    </Column>

                                    <Column class="status" field="status" :header="$t('dealNote.status')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <Dropdown v-model="filterModel.value" :options="statusArray" 
                                            @change="filterCallback()" class="w-full" placeholder="Status" />
                                        </template>
                                        <template #editor="{ data, field }">
                                            <Dropdown v-model="data[field]" :placeholder="data[field]"
                                            :options="statusArray" checkmark :highlightOnSelect="false" class="w-full"/>                                                                
                                        </template> 
                                        <template #body="slotProps">
                                            <Tag style="font-size: 10px" :value="slotProps.data.status" :severity="getStatusLabel(slotProps.data.status)" />
                                            <span class="warning" v-if="vesselSummaryCancelled(slotProps.data)" v-tooltip="'Planned: ' + slotProps.data.vesselSummaryStatus">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                    </Column>                            

                                    <Column dataType="date" field="laycanStartDate" :header="$t('dealNote.laycanStartDate')">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <Calendar v-model="filterModel.value" dateFormat="dd/mm/yy" placeholder="dd/mm/yyyy" mask="99/99/9999" @keydown.enter="filterCallback()" />
                                        </template>
                                        <template #body="{ data, field }">
                                            <span>{{data[field] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                                            <span class="warning" v-if="checkStatus(data) && data[field].getTime() != data.plannedLaycanStartDate.getTime()" v-tooltip="'Planned: ' + utils.formatDateTime(utils.dateToCurrentTimeZone(data.plannedLaycanStartDate))">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                        <template #editor="{ data, field }">   
                                            <Calendar 
                                                v-if="isVoyageEditable(data)"
                                                class="w-full" 
                                                showTime hourFormat="24"
                                                v-model="data[field]" 
                                                dateFormat="dd/mm/yy" 
                                                placeholder="dd/mm/yyyy"/> 
                                            <span v-else>{{data[field] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data[field])) : null}}</span>                                                                  
                                        </template>
                                    </Column>
                                    <Column dataType="date" field="laycanEndDate" :header="$t('dealNote.laycanEndDate')">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <Calendar v-model="filterModel.value" dateFormat="dd/mm/yy" placeholder="dd/mm/yyyy" mask="99/99/9999" @keydown.enter="filterCallback()"/>
                                        </template>
                                        <template #body="{ data, field }">
                                            <span>{{data[field] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                                            <span class="warning" v-if="checkStatus(data) && data[field].getTime() != data.plannedLaycanEndDate.getTime()" v-tooltip="'Planned: ' + utils.formatDateTime(utils.dateToCurrentTimeZone(data.plannedLaycanEndDate))">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                        <template #editor="{ data, field }">  
                                            <Calendar 
                                                v-if="isVoyageEditable(data)"
                                                class="w-full" 
                                                showTime hourFormat="24"
                                                v-model="data[field]" 
                                                dateFormat="dd/mm/yy" 
                                                placeholder="dd/mm/yyyy"/>  
                                            <span v-else>{{data[field] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data[field])) : null}}</span>                                                                    
                                        </template>
                                    </Column>

                                    <Column field="quantity" :header="$t('dealNote.quantity')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ utils.formatInteger(data[field]) }}</span>
                                            <span class="warning" v-if="checkStatus(data) && data[field] != data.plannedQuantity" v-tooltip="'Planned: ' + utils.formatInteger(data.plannedQuantity)">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                        <template #editor="{ data, field }">
                                            <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="0" v-if="isVoyageEditable(data)" />
                                            <span v-else>{{ utils.formatInteger(data[field]) }}</span>
                                        </template>
                                    </Column>

                                    <Column field="minimumQuantity" :header="$t('dealNote.minimumQuantity')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ utils.formatInteger(data[field]) }}</span>
                                            <span class="warning" v-if="checkStatus(data) && data[field] != data.plannedMinimumQuantity" v-tooltip="'Planned: ' + utils.formatInteger(data.plannedMinimumQuantity)">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                        <template #editor="{ data, field }">
                                            <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="0" v-if="isVoyageEditable(data)" />
                                            <span v-else>{{ utils.formatInteger(data[field]) }}</span>
                                        </template>
                                    </Column>

                                    <Column field="maximumQuantity" :header="$t('dealNote.maximumQuantity')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ utils.formatInteger(data[field]) }}</span>
                                            <span class="warning" v-if="checkStatus(data) && data[field] != data.plannedMaximumQuantity" v-tooltip="'Planned: ' + utils.formatInteger(data.plannedMaximumQuantity)">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                        <template #editor="{ data, field }">
                                            <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="0" v-if="isVoyageEditable(data)" />
                                            <span v-else>{{ utils.formatInteger(data[field]) }}</span>
                                        </template>
                                    </Column>

                                    <Column field="quantityKbbl" :header="$t('dealNote.quantityKbbl')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ utils.formatInteger(data[field]) }}</span>
                                        </template>
                                        <template #editor="{ data, field }">
                                            <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="0" v-if="isVoyageEditable(data)" />
                                            <span v-else>{{ utils.formatInteger(data[field]) }}</span>
                                        </template>
                                    </Column>

                                    <!--<Column field="quantityUoM" :header="$t('dealNote.uom')" style="width: 150px;">
                                        <template #editor="{ data, field }">
                                            <InputText class="w-full" v-model="data[field]" v-if="isVoyageEditable(data)"/>
                                            <span v-else>{{ data[field] }}</span>
                                        </template>
                                    </Column> -->

                                    <Column field="quality" :header="$t('dealNote.quality')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search"/>
                                        </template>
                                        <template #editor="{ data, field }">
                                            <InputText v-model="data[field]" class="w-full" />
                                            <!--<GenericCustomMasterDataAutocompleteV2
                                                class="w-full"
                                                :name="`registry-deal-note-column-combo?family=${data.family}&columnType=${field}`"
                                                v-model="data[field]"
                                                :api="`masterdata/registry-deal-note-column-combo?family=${data.family}&columnType=${field}`"/>-->                            
                                        </template>
                                    </Column>

                                    <Column field="econs" :header="$t('dealNote.econs')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search"/>
                                        </template>
                                        <template #editor="{ data, field }">
                                            <Textarea class="w-full" autoResize v-model="data[field]" />
                                        </template>
                                    </Column>

                                    <Column field="marker" :header="$t('dealNote.marker')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search"/>
                                        </template>
                                        <template #editor="{ data, field }">
                                            <GenericCustomMasterDataAutocompleteV2
                                                class="w-full"
                                                name= "true-up/price-formula-combo"
                                                v-model="data[field]"
                                                api="true-up/price-formula-combo"/>                            
                                        </template>
                                    </Column>

                                    <Column field="priceWindow" :header="$t('dealNote.priceWindow')" style="min-width: 220px">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search"/>
                                        </template>
                                        <template #editor="{ data }">
                                            <div class="grid">
                                                <div class="col-10">
                                                    <label>{{ $t("dealNote.labelPriceWindow") }}</label>
                                                    <GenericCustomMasterDataAutocompleteV2
                                                        class="w-full"
                                                        name= "planning/deal-note-price-window-combo"
                                                        v-model="data.idRegistryPriceWindowType"
                                                        :changeFn="onUpdatePriceWindow"
                                                        :refLabel="data"
                                                        :api="`masterdata/price-window-type-combo`"/> 
                                                        
                                                </div>

                                                <div class="col-12" v-if="data.idRegistryPriceWindowType == 1">
                                                    <label>{{ $t("dealNote.labelDatePriceWindow") }}</label>
                                                    <Calendar
                                                        class="p-inputtext-sm w-full"
                                                        placeholder="__/__/____"
                                                        v-model="data.monthDate"
                                                        dateFormat="mm/yy" :showTime="false"
                                                        :showIcon="true" :showButtonBar="true" :yearNavigator="true" 
                                                        view="month" />
                                                </div>
                                                
                                                <div class="col-12" v-else-if="data.idRegistryPriceWindowType == 5">
                                                    <div class="grid">
                                                        <div class="col-12 lg:col-6 w-full">
                                                            <label>{{ $t("from") }}</label>
                                                            <Calendar
                                                                class="p-inputtext-sm w-full"
                                                                placeholder="__/__/____"
                                                                v-model="data.dateFrom"
                                                                dateFormat="dd/mm/yy" :showTime="false"
                                                                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                                                        </div>
                                                        <div class="col-12 lg:col-6 w-full">
                                                            <label>{{ $t("to") }}</label>
                                                            <Calendar
                                                                class="p-inputtext-sm w-full"
                                                                placeholder="__/__/____"
                                                                v-model="data.dateTo"
                                                                dateFormat="dd/mm/yy" :showTime="false"
                                                                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                                                        </div>
                                                    </div>                                                
                                                </div>

                                                <div class="col-12" v-else-if="data.idRegistryPriceWindowType">
                                                    <div class="grid">
                                                        <div class="col-12 lg:col-8">
                                                            <label>{{ $t("from") }}</label>
                                                            <Calendar
                                                                class="p-inputtext-sm w-full"
                                                                placeholder="__/__/____"
                                                                v-model="data.dateFrom"
                                                                dateFormat="dd/mm/yy" :showTime="false"
                                                                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                                                        </div>

                                                        <div class="col-12 lg:col-4">
                                                            <label>{{ $t("Include") }}</label>
                                                            <Checkbox class="my-1 w-full" v-model="data.isReferenceDateIncluded" :binary="true" /> 
                                                        </div>                                                          
                                                    </div>                                                                                                                                            
                                                </div>                                           
                                            </div>
                                        </template>
                                        <template #body="{ data, field }">
                                            <span>{{ data[field] }}</span>                                              
                                            <span v-if="data.idRegistryPriceWindowType != 1 && data.idRegistryPriceWindowType != 5">&nbsp; {{ data.dateFrom != null ? utils.formatDate(data.dateFrom) : null }}</span>                                                                         
                                        </template> 
                                    </Column>
                                    
                                    <Column field="premium" :header="$t('dealNote.premium')" style="width: 150px;">  
                                        <template #body="{ data, field }">
                                            <span>{{ utils.formatDecimal(data[field], 3, "it-IT") }}</span>                                  
                                        </template>                            
                                        <template #editor="{ data, field }">
                                            <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="3" />
                                        </template>
                                    </Column>

                                    <Column field="dfl" :header="$t('dealNote.dfl')" style="width: 150px;">  
                                        <template #body="{ data, field }">
                                            <span>{{ utils.formatDecimal(data[field], 3, "it-IT") }}</span>                                  
                                        </template>                       
                                        <template #editor="{ data, field }">
                                            <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="3" />
                                        </template>
                                    </Column>

                                    <Column field="margin" :header="$t('dealNote.margin')" style="width: 150px;">  
                                        <template #body="{ data, field }">
                                            <span>{{ utils.formatDecimal(data[field], 2, "it-IT") }}</span>                                  
                                        </template>                            
                                        <template #editor="{ data, field }">
                                            <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="2" />
                                        </template>
                                    </Column>

                                    <Column field="buyerSeller" :header="$t('dealNote.buyerSeller')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search"/>
                                        </template>
                                        <template #editor="{data}">
                                            <GenericCustomMasterDataAutocompleteV2 
                                                class="p-inputtext-sm w-full"
                                                v-model="data.idBuyerSeller"
                                                api="masterdata/company-combo" 
                                                name="masterdata-company-combo"
                                                v-if="isVoyageEditable(data)" />    
                                                <span v-else>{{ data.buyerSeller }}</span>                            
                                        </template>
                                    </Column>

                                    <Column field="benchmark" :header="$t('dealNote.benchmark')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter " placeholder="Search"/>
                                        </template>
                                        <template #editor="{ data, field }">
                                            <Textarea class="w-full" autoResize v-model="data[field]" />
                                        </template>
                                    </Column>

                                    <Column field="contractualCoefficient" :header="$t('dealNote.contractualCoefficient')" style="width: 150px;">  
                                        <template #body="{ data, field }">
                                            <span>{{ utils.formatInteger(data[field], "it-IT") }}</span>                                  
                                        </template>                            
                                        <template #editor="{ data, field }">
                                            <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="0" />
                                        </template>
                                    </Column>

                                    <Column field="provisionalDensity" :header="$t('dealNote.provisionalDensity')" style="width: 150px;">  
                                        <template #body="{ data, field }">
                                            <span>{{ data[field] }}</span>                                  
                                        </template>                            
                                        <template #editor="{ data, field }">
                                            <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="4" />
                                        </template>
                                    </Column>

                                    <Column field="platts" :header="$t('dealNote.platts')" style="width: 150px;">  
                                        <template #body="{ data, field }">
                                            <span>{{ utils.formatDecimal(data[field], 2, "it-IT") }}</span>                                  
                                        </template>                         
                                        <template #editor="{ data, field }">
                                            <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="2" />
                                        </template>
                                    </Column>

                                    <Column field="comment" :header="$t('dealNote.comment')" style="width: 300px;">
                                        <template #editor="{ data, field }">
                                            <Textarea class="w-full" autoResize v-model="data[field]" />
                                        </template>
                                    </Column>

                                    <template #groupheader="slotProps">
                                        <div class="flex align-items-center gap-2">
                                            <span>{{ slotProps.data.family }}</span>
                                        </div>
                                    </template>
                            </DataTable>
                        </div>
                    </div>
                </TabPanel>
                <TabPanel header="Diesel">
                    <div class="grid">
                        <div class="col-12" style="height: calc(75vh)" >
                            <DataTable showGridlines :value="dealNote.dieselSheet" scrollable :responsiveLayout="'stack'" scrollHeight="flex" rowGroupMode="subheader" groupRowsBy="family" sortMode="single"
                                :sortOrder="1" editMode="row" size="small" v-model:editing-rows="editDataCrude" @row-edit-save="onCrudeRowEditSave" 
                                v-model:filters="dieselFilters" filterDisplay="row" dataKey="id" :rowClass="rowClass" >
                                    
                                    <Column frozen style="width: 180px" class="button-column" :exportable="false" :reorderableColumn="false">
                                        <template #body="slotProps">
                                            <Button v-tooltip="$t('dealNote.uploadDocument')" icon="fa-solid fa-upload" class="p-button-sm p-button-rounded p-button-outlined mr-1 mb-1" size="small" 
                                            @click="openUploadDialog(slotProps.data)" v-if="!uiPermissions('dealNoteUploadDocument').isHidden" />
                                            <Button v-tooltip="$t('dealNote.downloadDocument')" icon="fa-solid fa-download" class="p-button-sm p-button-rounded p-button-outlined mr-1 mb-1" size="small" @click="openDownloadDialog(slotProps.data)" />
                                            <Button v-tooltip="$t('dealNote.openLog')" icon="fa-solid fa-file-lines" class="p-button-sm p-button-rounded p-button-outlined mr-1 mb-1" size="small" @click="openLogDialog(slotProps.data)" />
                                            <Button v-tooltip="$t('dealNote.clone')" icon="fa-solid fa-code-merge" class="p-button-sm p-button-rounded p-button-outlined mr-1 mb-1" size="small" 
                                            @click="cloneDeal(slotProps.data)" v-if="!uiPermissions('dealNoteCloneButton').isHidden" />
                                            <span class="warning" v-if="slotProps.data.isUpdateBlocked" v-tooltip="$t('dealNote.updateBlocked')">
                                                <i class="fas fa-lock" style='font-size:10px; color:black;' />
                                            </span>
                                        </template>
                                    </Column>
                                    <Column frozen :rowEditor="true" style="width: 150px;" v-if="!uiPermissions('dealNoteEditButton').isHidden" />

                                    <Column field="family" :header="$t('dealNote.family')">
                                        <template #body="{ data, field }">
                                            <span>
                                                {{ data[field] }}
                                                <Tag severity="warning" value="Modified" v-if="data[field + '_dirty']" />
                                            </span>
                                        </template>
                                    </Column>
                                                            
                                    <!---<Column field="family" :header="$t('dealNote.family')" style="width: 150px;"></Column> -->

                                    <Column field="dealDate" :header="$t('dealNote.dealDate')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{data[field] != null ? utils.formatDate(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                                        </template>
                                        <template #editor="{ data, field }">   
                                            <Calendar 
                                                class="w-full" 
                                                v-model="data[field]" 
                                                dateFormat="dd/mm/yy" 
                                                placeholder="dd/mm/yyyy" v-if="isVoyageEditable(data)"/>                                 
                                            <span v-else>{{data[field] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                                        </template>                       
                                    </Column>

                                    <Column field="voyageNumber" :header="$t('dealNote.voyageNumber')" style="width: 150px;"> 
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search"/>
                                        </template>                           
                                    </Column>

                                    <Column field="registryProduct" :header="$t('dealNote.product')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                                        </template>
                                        <template #body="{ data, field }">
                                            <span>{{ data[field] }}</span>
                                            <span class="warning" v-if="checkStatus(data) && data[field] != data.plannedRegistryProduct" v-tooltip="'Planned: ' + data.plannedRegistryProduct">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                        <template #editor="{data}">
                                            <GenericCustomMasterDataAutocompleteV2
                                            class="p-inputtext-sm w-full"
                                            v-model="data.idRegistryProduct"
                                            api="masterdata/product-combo" 
                                            name="masterdata-product-combo" 
                                            v-if="isVoyageEditable(data)"/> 
                                            <span v-else>{{ slotProps.data.registryProduct }}</span>                                    
                                        </template>
                                    </Column>

                                    <Column field="grade" :header="$t('dealNote.grade')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                                        </template>
                                        <template #editor="{ data, field }">
                                            <InputText v-model="data[field]" class="w-full" />
                                            <!-- <GenericCustomMasterDataAutocompleteV2
                                                class="w-full"
                                                :name="`registry-deal-note-column-combo?family=${data.family}&columnType=${field}`"
                                                v-model="data[field]"
                                                :api="`masterdata/registry-deal-note-column-combo?family=${data.family}&columnType=${field}`"/>                             -->
                                        </template>
                                    </Column>

                                    <Column field="isabCode" :header="$t('dealNote.isabCode')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                                        </template>
                                    </Column>

                                    <Column field="terminal" :header="$t('dealNote.terminal')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <Dropdown v-model="filterModel.value" :options="terminalArray" 
                                            @change="filterCallback()" class="w-full" placeholder="Terminal" />
                                        </template>
                                        <template #body="{ data, field }">
                                            <span>{{ data[field] }}</span>
                                            <span class="warning" v-if="checkStatus(data) && data[field] != data.plannedTerminal" v-tooltip="'Planned: ' + data.plannedTerminal">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                        <template #editor="{data}">
                                            <GenericCustomMasterDataAutocompleteV2
                                                class="p-inputtext-sm w-full"
                                                v-model="data.idRegistryPlant"
                                                api="masterdata/registry-plant-combo" 
                                                name="masterdata-registry-plant-combo" 
                                                v-if="isVoyageEditable(data)" />    
                                                <span v-else>{{ data.terminal }}</span>                                  
                                        </template>
                                    </Column>

                                    <Column field="registryVessel" :header="$t('dealNote.registryVessel')" style="width: 150px;">                                                             
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search"/>
                                        </template>
                                    </Column>

                                    <Column class="status" field="status" :header="$t('dealNote.status')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <Dropdown v-model="filterModel.value" :options="statusArray" 
                                            @change="filterCallback()" class="w-full" placeholder="Status" />
                                        </template>                                
                                        <template #editor="{ data, field }">
                                            <Dropdown v-model="data[field]" :placeholder="data[field]"
                                            :options="statusArray" checkmark :highlightOnSelect="false" class="w-full"/>                                                                
                                        </template> 
                                        <template #body="slotProps">
                                            <Tag style="font-size: 10px" :value="slotProps.data.status" :severity="getStatusLabel(slotProps.data.status)" />
                                            <span class="warning" v-if="vesselSummaryCancelled(slotProps.data)" v-tooltip="'Planned: ' + slotProps.data.vesselSummaryStatus">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                    </Column>                            

                                    <Column field="laycanStartDate" :header="$t('dealNote.laycanStartDate')">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <Calendar                                                                        
                                                class="w-full" 
                                                showTime hourFormat="24"
                                                v-model="filterModel.value" 
                                                @keydown.enter="filterCallback()"  
                                                dateFormat="dd/mm/yy" 
                                                placeholder="dd/mm/yyyy"/> 
                                        </template>
                                        <template #body="{ data, field }">
                                            <span>{{data[field] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                                            <span class="warning" v-if="checkStatus(data) && data[field].getTime() != data.plannedLaycanStartDate.getTime()" v-tooltip="'Planned: ' + utils.formatDateTime(utils.dateToCurrentTimeZone(data.plannedLaycanStartDate))">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                        <template #editor="{ data, field }">   
                                            <Calendar 
                                                v-if="isVoyageEditable(data)"
                                                class="w-full" 
                                                showTime hourFormat="24"
                                                v-model="data[field]" 
                                                dateFormat="dd/mm/yy" 
                                                placeholder="dd/mm/yyyy"/> 
                                            <span v-else>{{data[field] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data[field])) : null}}</span>                                                                  
                                        </template>
                                    </Column>
                                    <Column field="laycanEndDate" :header="$t('dealNote.laycanEndDate')">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <Calendar                                                                        
                                                class="w-full" 
                                                showTime hourFormat="24"
                                                v-model="filterModel.value" 
                                                @keydown.enter="filterCallback()"  
                                                dateFormat="dd/mm/yy" 
                                                placeholder="dd/mm/yyyy"/> 
                                        </template>
                                        <template #body="{ data, field }">
                                            <span>{{data[field] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                                            <span class="warning" v-if="checkStatus(data) && data[field].getTime() != data.plannedLaycanEndDate.getTime()" v-tooltip="'Planned: ' + utils.formatDateTime(utils.dateToCurrentTimeZone(data.plannedLaycanEndDate))">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                        <template #editor="{ data, field }">  
                                            <Calendar 
                                                v-if="isVoyageEditable(data)"
                                                class="w-full" 
                                                showTime hourFormat="24"
                                                v-model="data[field]" 
                                                dateFormat="dd/mm/yy" 
                                                placeholder="dd/mm/yyyy"/>  
                                            <span v-else>{{data[field] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data[field])) : null}}</span>                                                                    
                                        </template>
                                    </Column>

                                    <Column field="quantity" :header="$t('dealNote.quantity')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ utils.formatInteger(data[field]) }}</span>
                                            <span class="warning" v-if="checkStatus(data) && data[field] != data.plannedQuantity" v-tooltip="'Planned: ' + utils.formatInteger(data.plannedQuantity)">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                        <template #editor="{ data, field }">
                                            <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="0" v-if="isVoyageEditable(data)" />
                                            <span v-else>{{ utils.formatInteger(data[field]) }}</span>
                                        </template>
                                    </Column>

                                    <Column field="minimumQuantity" :header="$t('dealNote.minimumQuantity')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ utils.formatInteger(data[field]) }}</span>
                                            <span class="warning" v-if="checkStatus(data) && data[field] != data.plannedMinimumQuantity" v-tooltip="'Planned: ' + utils.formatInteger(data.plannedMinimumQuantity)">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                        <template #editor="{ data, field }">
                                            <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="0" v-if="isVoyageEditable(data)" />
                                            <span v-else>{{ utils.formatInteger(data[field]) }}</span>
                                        </template>
                                    </Column>

                                    <Column field="maximumQuantity" :header="$t('dealNote.maximumQuantity')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ utils.formatInteger(data[field]) }}</span>
                                            <span class="warning" v-if="checkStatus(data) && data[field] != data.plannedMaximumQuantity" v-tooltip="'Planned: ' + utils.formatInteger(data.plannedMaximumQuantity)">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                        <template #editor="{ data, field }">
                                            <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="0" v-if="isVoyageEditable(data)" />
                                            <span v-else>{{ utils.formatInteger(data[field]) }}</span>
                                        </template>
                                    </Column>

                                    <Column field="quantityUoM" :header="$t('dealNote.uom')" style="width: 150px;">
                                        <template #editor="{ data, field }">
                                            <InputText class="w-full" v-model="data[field]" v-if="isVoyageEditable(data)"/>
                                            <span v-else>{{ data[field] }}</span>
                                        </template>
                                    </Column>

                                    <Column field="quality" :header="$t('dealNote.quality')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                                        </template>
                                        <template #editor="{ data, field }">
                                            <InputText v-model="data[field]" class="w-full" />
                                            <!-- <GenericCustomMasterDataAutocompleteV2
                                                class="w-full"
                                                :name="`registry-deal-note-column-combo?family=${data.family}&columnType=${field}`"
                                                v-model="data[field]"
                                                :api="`masterdata/registry-deal-note-column-combo?family=${data.family}&columnType=${field}`"/> -->                           
                                        </template>
                                    </Column>

                                    <Column field="econs" :header="$t('dealNote.econs')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                                        </template>
                                        <template #editor="{ data, field }">
                                            <Textarea class="w-full" autoResize v-model="data[field]" />
                                        </template>
                                    </Column>

                                    <Column field="marker" :header="$t('dealNote.marker')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                                        </template>
                                        <template #editor="{ data, field }">
                                            <GenericCustomMasterDataAutocompleteV2
                                                class="w-full"
                                                name= "true-up/price-formula-combo"
                                                v-model="data[field]"
                                                api="true-up/price-formula-combo"/>                          
                                        </template>
                                    </Column>

                                    <Column field="priceWindow" :header="$t('dealNote.priceWindow')" style="min-width: 220px">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search"/>
                                        </template>
                                        <template #editor="{ data }">
                                            <div class="grid">
                                                <div class="col-10">
                                                    <label>{{ $t("dealNote.labelPriceWindow") }}</label>
                                                    <GenericCustomMasterDataAutocompleteV2
                                                        class="w-full"
                                                        name= "planning/deal-note-price-window-combo"
                                                        v-model="data.idRegistryPriceWindowType"
                                                        :changeFn="onUpdatePriceWindow"
                                                        :refLabel="data"
                                                        :api="`masterdata/price-window-type-combo`"/> 
                                                        
                                                </div>

                                                <div class="col-12" v-if="data.idRegistryPriceWindowType == 1">
                                                    <label>{{ $t("dealNote.labelDatePriceWindow") }}</label>
                                                    <Calendar
                                                        class="p-inputtext-sm w-full"
                                                        placeholder="__/__/____"
                                                        v-model="data.monthDate"
                                                        dateFormat="mm/yy" :showTime="false"
                                                        :showIcon="true" :showButtonBar="true" :yearNavigator="true" 
                                                        view="month" />
                                                </div>
                                                
                                                <div class="col-12" v-else-if="data.idRegistryPriceWindowType == 5">
                                                    <div class="grid">
                                                        <div class="col-12 lg:col-6 w-full">
                                                            <label>{{ $t("from") }}</label>
                                                            <Calendar
                                                                class="p-inputtext-sm w-full"
                                                                placeholder="__/__/____"
                                                                v-model="data.dateFrom"
                                                                dateFormat="dd/mm/yy" :showTime="false"
                                                                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                                                        </div>
                                                        <div class="col-12 lg:col-6 w-full">
                                                            <label>{{ $t("to") }}</label>
                                                            <Calendar
                                                                class="p-inputtext-sm w-full"
                                                                placeholder="__/__/____"
                                                                v-model="data.dateTo"
                                                                dateFormat="dd/mm/yy" :showTime="false"
                                                                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                                                        </div>
                                                    </div>                                                
                                                </div>

                                                <div class="col-12" v-else-if="data.idRegistryPriceWindowType">
                                                    <div class="grid">
                                                        <div class="col-12 lg:col-8">
                                                            <label>{{ $t("from") }}</label>
                                                            <Calendar
                                                                class="p-inputtext-sm w-full"
                                                                placeholder="__/__/____"
                                                                v-model="data.dateFrom"
                                                                dateFormat="dd/mm/yy" :showTime="false"
                                                                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                                                        </div>

                                                        <div class="col-12 lg:col-4">
                                                            <label>{{ $t("Include") }}</label>
                                                            <Checkbox class="my-1 w-full" v-model="data.isReferenceDateIncluded" :binary="true" /> 
                                                        </div>                                                          
                                                    </div>                                                                                                                                            
                                                </div>                                           
                                            </div>
                                        </template>
                                        <template #body="{ data, field }">
                                            <span>{{ data[field] }}</span>                                              
                                            <span v-if="data.idRegistryPriceWindowType != 1 && data.idRegistryPriceWindowType != 5">&nbsp; {{ data.dateFrom != null ? utils.formatDate(data.dateFrom) : null }}</span>                                                                         
                                        </template> 
                                    </Column>

                                    <Column field="premiumBase" :header="$t('dealNote.premiumBase')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ utils.formatDecimal(data[field], 3, "it-IT") }}</span>                                  
                                        </template>
                                        <template #editor="{ data, field }">
                                            <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="3" />
                                        </template>
                                    </Column>

                                    <Column field="qualityPremium" :header="$t('dealNote.qualityPremium')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ utils.formatDecimal(data[field], 3, "it-IT") }}</span>                                  
                                        </template>
                                        <template #editor="{ data, field }">
                                            <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="3" />
                                        </template>
                                    </Column>

                                    <!--<Column field="dfl" :header="$t('dealNote.dfl')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                                        </template>
                                        <template #editor="{ data, field }">
                                            <InputText class="w-full" v-model="data[field]" />
                                        </template>
                                    </Column> -->

                                    <Column field="margin" :header="$t('dealNote.margin')" style="width: 150px;">  
                                        <template #body="{ data, field }">
                                            <span>{{ utils.formatDecimal(data[field], 2, "it-IT") }}</span>                                  
                                        </template>                             
                                        <template #editor="{ data, field }">
                                            <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="2" />
                                        </template>
                                    </Column>

                                    <Column field="buyerSeller" :header="$t('dealNote.buyerSeller')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                                        </template>
                                        <template #editor="{data}">
                                            <GenericCustomMasterDataAutocompleteV2 
                                                class="p-inputtext-sm w-full"
                                                v-model="data.idBuyerSeller"
                                                api="masterdata/company-combo" 
                                                name="masterdata-company-combo" 
                                                v-if="isVoyageEditable(data)" />    
                                                <span v-else>{{ data.buyerSeller }}</span>                            
                                        </template>
                                    </Column>

                                    <Column field="benchmark" :header="$t('dealNote.benchmark')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                                        </template>
                                        <template #editor="{ data, field }">
                                            <Textarea class="w-full" autoResize v-model="data[field]" />
                                        </template>
                                    </Column>

                                    <Column field="comment" :header="$t('dealNote.comment')" style="width: 300px;">
                                        <template #editor="{ data, field }">
                                            <Textarea class="w-full" autoResize v-model="data[field]" />
                                        </template>
                                    </Column>

                                    <template #groupheader="slotProps">
                                        <div class="flex align-items-center gap-2">
                                            <span>{{ slotProps.data.family }}</span>
                                        </div>
                                    </template>
                            </DataTable>
                        </div>
                    </div>
                </TabPanel>
                <TabPanel header="Gasoline">
                    <div class="grid">
                        <div class="col-12" style="height: calc(75vh)" >
                            <DataTable showGridlines :value="dealNote.gasolineSheet" scrollable :responsiveLayout="'stack'" scrollHeight="flex" rowGroupMode="subheader" groupRowsBy="family" sortMode="single"
                                :sortOrder="1" editMode="row" size="small" v-model:editing-rows="editDataCrude" @row-edit-save="onCrudeRowEditSave" 
                                v-model:filters="gasolineFilters" filterDisplay="row" dataKey="id" :rowClass="rowClass" >

                                    <Column frozen style="width: 180px" class="button-column" :exportable="false" :reorderableColumn="false">
                                        <template #body="slotProps">
                                            <Button v-tooltip="$t('dealNote.uploadDocument')" icon="fa-solid fa-upload" class="p-button-sm p-button-rounded p-button-outlined mr-1 mb-1" size="small" 
                                            @click="openUploadDialog(slotProps.data)" v-if="!uiPermissions('dealNoteUploadDocument').isHidden" />
                                            <Button v-tooltip="$t('dealNote.downloadDocument')" icon="fa-solid fa-download" class="p-button-sm p-button-rounded p-button-outlined mr-1 mb-1" size="small" @click="openDownloadDialog(slotProps.data)" />
                                            <Button v-tooltip="$t('dealNote.openLog')" icon="fa-solid fa-file-lines" class="p-button-sm p-button-rounded p-button-outlined mr-1 mb-1" size="small" @click="openLogDialog(slotProps.data)" />
                                            <Button v-tooltip="$t('dealNote.clone')" icon="fa-solid fa-code-merge" class="p-button-sm p-button-rounded p-button-outlined mr-1 mb-1" size="small" 
                                            @click="cloneDeal(slotProps.data)" v-if="!uiPermissions('dealNoteCloneButton').isHidden" />
                                            <span class="warning" v-if="slotProps.data.isUpdateBlocked" v-tooltip="$t('dealNote.updateBlocked')">
                                                <i class="fas fa-lock" style='font-size:10px; color:black;' />
                                            </span>
                                        </template>
                                    </Column>
                                    <Column frozen :rowEditor="true" style="width: 150px;" v-if="!uiPermissions('dealNoteEditButton').isHidden" />

                                    <Column field="family" :header="$t('dealNote.family')">
                                        <template #body="{ data, field }">
                                            <span>
                                                {{ data[field] }}
                                                <Tag severity="warning" value="Modified" v-if="data[field + '_dirty']" />
                                            </span>
                                        </template>
                                    </Column>
                                                            
                                    <!---<Column field="family" :header="$t('dealNote.family')" style="width: 150px;"></Column> -->

                                    <Column field="dealDate" :header="$t('dealNote.dealDate')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{data[field] != null ? utils.formatDate(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                                        </template>
                                        <template #editor="{ data, field }">   
                                            <Calendar 
                                                class="w-full" 
                                                v-model="data[field]" 
                                                dateFormat="dd/mm/yy" 
                                                placeholder="dd/mm/yyyy" v-if="isVoyageEditable(data)"/>                                 
                                            <span v-else>{{data[field] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                                        </template>                       
                                    </Column>

                                    <Column field="voyageNumber" :header="$t('dealNote.voyageNumber')" style="width: 150px;"> 
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search"/>
                                        </template>                           
                                    </Column>

                                    <Column field="registryProduct" :header="$t('dealNote.product')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                                        </template>
                                        <template #body="{ data, field }">
                                            <span>{{ data[field] }}</span>
                                            <span class="warning" v-if="checkStatus(data) && data[field] != data.plannedRegistryProduct" v-tooltip="'Planned: ' + data.plannedRegistryProduct">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                        <template #editor="{data}">
                                            <GenericCustomMasterDataAutocompleteV2
                                            class="p-inputtext-sm w-full"
                                            v-model="data.idRegistryProduct"
                                            api="masterdata/product-combo" 
                                            name="masterdata-product-combo" 
                                            v-if="isVoyageEditable(data)"/> 
                                            <span v-else>{{ data.registryProduct }}</span>                                    
                                        </template>
                                    </Column>

                                    <Column field="grade" :header="$t('dealNote.grade')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                                        </template>
                                         <template #editor="{ data, field }">
                                            <InputText v-model="data[field]" class="w-full" />
                                            <!-- <GenericCustomMasterDataAutocompleteV2
                                                class="w-full"
                                                :name="`registry-deal-note-column-combo?family=${data.family}&columnType=${field}`"
                                                v-model="data[field]"
                                                :api="`masterdata/registry-deal-note-column-combo?family=${data.family}&columnType=${field}`"/>  -->
                                        </template>
                                    </Column>

                                    <Column field="isabCode" :header="$t('dealNote.isabCode')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                                        </template>
                                    </Column>

                                    <Column field="terminal" :header="$t('dealNote.terminal')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <Dropdown v-model="filterModel.value" :options="terminalArray" 
                                            @change="filterCallback()" class="w-full" placeholder="Terminal" />
                                        </template>
                                        <template #body="{ data, field }">
                                            <span>{{ data[field] }}</span>
                                            <span class="warning" v-if="checkStatus(data) && data[field] != data.plannedTerminal" v-tooltip="'Planned: ' + data.plannedTerminal">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                        <template #editor="{data}">
                                            <GenericCustomMasterDataAutocompleteV2 
                                                class="p-inputtext-sm w-full"
                                                v-model="data.idRegistryPlant"
                                                api="masterdata/registry-plant-combo" 
                                                name="masterdata-registry-plant-combo" 
                                                v-if="isVoyageEditable(data)" />    
                                                <span v-else>{{ data.terminal }}</span>                                  
                                        </template>
                                    </Column>

                                    <Column field="registryVessel" :header="$t('dealNote.registryVessel')" style="width: 150px;">                                                             
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search"/>
                                        </template>
                                    </Column>

                                    <Column class="status" field="status" :header="$t('dealNote.status')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <Dropdown v-model="filterModel.value" :options="statusArray" 
                                            @change="filterCallback()" class="w-full" placeholder="Status" />
                                        </template>
                                        <template #editor="{ data, field }">
                                            <Dropdown v-model="data[field]" :placeholder="data[field]"
                                            :options="statusArray" checkmark :highlightOnSelect="false" class="w-full"/>                                                                
                                        </template> 
                                        <template #body="slotProps">
                                            <Tag style="font-size: 10px" :value="slotProps.data.status" :severity="getStatusLabel(slotProps.data.status)" />
                                            <span class="warning" v-if="vesselSummaryCancelled(slotProps.data)" v-tooltip="'Planned: ' + slotProps.data.vesselSummaryStatus">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                    </Column>                            

                                    <Column field="laycanStartDate" :header="$t('dealNote.laycanStartDate')">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <Calendar                                                                        
                                                class="w-full" 
                                                showTime hourFormat="24"
                                                v-model="filterModel.value" 
                                                @keydown.enter="filterCallback()"  
                                                dateFormat="dd/mm/yy" 
                                                placeholder="dd/mm/yyyy"/> 
                                        </template>
                                        <template #body="{ data, field }">
                                            <span>{{data[field] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                                            <span class="warning" v-if="checkStatus(data) && data[field].getTime() != data.plannedLaycanStartDate.getTime()" v-tooltip="'Planned: ' + utils.formatDateTime(utils.dateToCurrentTimeZone(data.plannedLaycanStartDate))">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                        <template #editor="{ data, field }">   
                                            <Calendar 
                                                v-if="isVoyageEditable(data)"
                                                class="w-full" 
                                                showTime hourFormat="24"
                                                v-model="data[field]" 
                                                dateFormat="dd/mm/yy" 
                                                placeholder="dd/mm/yyyy"/> 
                                            <span v-else>{{data[field] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data[field])) : null}}</span>                                                                  
                                        </template>
                                    </Column>
                                    <Column field="laycanEndDate" :header="$t('dealNote.laycanEndDate')">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <Calendar                                                                        
                                                class="w-full" 
                                                showTime hourFormat="24"
                                                v-model="filterModel.value" 
                                                @keydown.enter="filterCallback()"  
                                                dateFormat="dd/mm/yy" 
                                                placeholder="dd/mm/yyyy"/> 
                                        </template>
                                        <template #body="{ data, field }">
                                            <span>{{data[field] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                                            <span class="warning" v-if="checkStatus(data) && data[field].getTime() != data.plannedLaycanEndDate.getTime()" v-tooltip="'Planned: ' + utils.formatDateTime(utils.dateToCurrentTimeZone(data.plannedLaycanEndDate))">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                        <template #editor="{ data, field }">  
                                            <Calendar 
                                                v-if="isVoyageEditable(data)"
                                                class="w-full" 
                                                showTime hourFormat="24"
                                                v-model="data[field]" 
                                                dateFormat="dd/mm/yy" 
                                                placeholder="dd/mm/yyyy"/>  
                                            <span v-else>{{data[field] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data[field])) : null}}</span>                                                                    
                                        </template>
                                    </Column>

                                    <Column field="quantity" :header="$t('dealNote.quantity')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ utils.formatInteger(data[field]) }}</span>
                                            <span class="warning" v-if="checkStatus(data) && data[field] != data.plannedQuantity" v-tooltip="'Planned: ' + utils.formatInteger(data.plannedQuantity)">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                        <template #editor="{ data, field }">
                                            <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="0" v-if="isVoyageEditable(data)" />
                                            <span v-else>{{ utils.formatInteger(data[field]) }}</span>
                                        </template>
                                    </Column>

                                    <Column field="minimumQuantity" :header="$t('dealNote.minimumQuantity')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ utils.formatInteger(data[field]) }}</span>
                                            <span class="warning" v-if="checkStatus(data) && data[field] != data.plannedMinimumQuantity" v-tooltip="'Planned: ' + utils.formatInteger(data.plannedMinimumQuantity)">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                        <template #editor="{ data, field }">
                                            <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="0" v-if="isVoyageEditable(data)" />
                                            <span v-else>{{ utils.formatInteger(data[field]) }}</span>
                                        </template>
                                    </Column>

                                    <Column field="maximumQuantity" :header="$t('dealNote.maximumQuantity')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ utils.formatInteger(data[field]) }}</span>
                                            <span class="warning" v-if="checkStatus(data) && data[field] != data.plannedMaximumQuantity" v-tooltip="'Planned: ' + utils.formatInteger(data.plannedMaximumQuantity)">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                        <template #editor="{ data, field }">
                                            <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="0" v-if="isVoyageEditable(data)" />
                                            <span v-else>{{ utils.formatInteger(data[field]) }}</span>
                                        </template>
                                    </Column>

                                    <Column field="quantityUoM" :header="$t('dealNote.uom')" style="width: 150px;">
                                        <template #editor="{ data, field }">
                                            <InputText class="w-full" v-model="data[field]" v-if="isVoyageEditable(data)"/>
                                            <span v-else>{{ data[field] }}</span>
                                        </template>
                                    </Column>

                                    <Column field="quality" :header="$t('dealNote.quality')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                                        </template>
                                        <template #editor="{ data, field }">
                                            <InputText v-model="data[field]" class="w-full" />
                                            <!--<GenericCustomMasterDataAutocompleteV2
                                                class="w-full"
                                                :name="`registry-deal-note-column-combo?family=${data.family}&columnType=${field}`"
                                                v-model="data[field]"
                                                :api="`masterdata/registry-deal-note-column-combo?family=${data.family}&columnType=${field}`"/> -->                            
                                        </template>
                                    </Column>

                                    <Column field="econs" :header="$t('dealNote.econs')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                                        </template>
                                        <template #editor="{ data, field }">
                                            <Textarea class="w-full" autoResize v-model="data[field]" />
                                        </template>
                                    </Column>

                                    <Column field="marker" :header="$t('dealNote.marker')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                                        </template>
                                        <template #editor="{ data, field }">
                                            <GenericCustomMasterDataAutocompleteV2
                                                class="w-full"
                                                name= "true-up/price-formula-combo"
                                                v-model="data[field]"
                                                api="true-up/price-formula-combo"/>                             
                                        </template>
                                    </Column>

                                    <Column field="priceWindow" :header="$t('dealNote.priceWindow')" style="min-width: 220px">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search"/>
                                        </template>
                                        <template #editor="{ data }">
                                            <div class="grid">
                                                <div class="col-10">
                                                    <label>{{ $t("dealNote.labelPriceWindow") }}</label>
                                                    <GenericCustomMasterDataAutocompleteV2
                                                        class="w-full"
                                                        name= "planning/deal-note-price-window-combo"
                                                        v-model="data.idRegistryPriceWindowType"
                                                        :changeFn="onUpdatePriceWindow"
                                                        :refLabel="data"
                                                        :api="`masterdata/price-window-type-combo`"/> 
                                                        
                                                </div>

                                                <div class="col-12" v-if="data.idRegistryPriceWindowType == 1">
                                                    <label>{{ $t("dealNote.labelDatePriceWindow") }}</label>
                                                    <Calendar
                                                        class="p-inputtext-sm w-full"
                                                        placeholder="__/__/____"
                                                        v-model="data.monthDate"
                                                        dateFormat="mm/yy" :showTime="false"
                                                        :showIcon="true" :showButtonBar="true" :yearNavigator="true" 
                                                        view="month" />
                                                </div>
                                                
                                                <div class="col-12" v-else-if="data.idRegistryPriceWindowType == 5">
                                                    <div class="grid">
                                                        <div class="col-12 lg:col-6 w-full">
                                                            <label>{{ $t("from") }}</label>
                                                            <Calendar
                                                                class="p-inputtext-sm w-full"
                                                                placeholder="__/__/____"
                                                                v-model="data.dateFrom"
                                                                dateFormat="dd/mm/yy" :showTime="false"
                                                                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                                                        </div>
                                                        <div class="col-12 lg:col-6 w-full">
                                                            <label>{{ $t("to") }}</label>
                                                            <Calendar
                                                                class="p-inputtext-sm w-full"
                                                                placeholder="__/__/____"
                                                                v-model="data.dateTo"
                                                                dateFormat="dd/mm/yy" :showTime="false"
                                                                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                                                        </div>
                                                    </div>                                                
                                                </div>

                                                <div class="col-12" v-else-if="data.idRegistryPriceWindowType">
                                                    <div class="grid">
                                                        <div class="col-12 lg:col-8">
                                                            <label>{{ $t("from") }}</label>
                                                            <Calendar
                                                                class="p-inputtext-sm w-full"
                                                                placeholder="__/__/____"
                                                                v-model="data.dateFrom"
                                                                dateFormat="dd/mm/yy" :showTime="false"
                                                                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                                                        </div>

                                                        <div class="col-12 lg:col-4">
                                                            <label>{{ $t("Include") }}</label>
                                                            <Checkbox class="my-1 w-full" v-model="data.isReferenceDateIncluded" :binary="true" /> 
                                                        </div>                                                          
                                                    </div>                                                                                                                                            
                                                </div>                                           
                                            </div>
                                        </template>
                                        <template #body="{ data, field }">
                                            <span>{{ data[field] }}</span>                                              
                                            <span v-if="data.idRegistryPriceWindowType != 1 && data.idRegistryPriceWindowType != 5">&nbsp; {{ data.dateFrom != null ? utils.formatDate(data.dateFrom) : null }}</span>                                                                         
                                        </template> 
                                    </Column>

                                    <Column field="premiumBase" :header="$t('dealNote.premiumBase')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ utils.formatDecimal(data[field], 3, "it-IT") }}</span>                                  
                                        </template>
                                        <template #editor="{ data, field }">
                                            <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="3" />
                                        </template>
                                    </Column>

                                    <Column field="qualityPremium" :header="$t('dealNote.qualityPremium')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ utils.formatDecimal(data[field], 3, "it-IT") }}</span>                                  
                                        </template>
                                        <template #editor="{ data, field }">
                                            <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="3" />
                                        </template>
                                    </Column>

                                <!-- <Column field="dfl" :header="$t('dealNote.dfl')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                                        </template>
                                        <template #editor="{ data, field }">
                                            <InputText class="w-full" v-model="data[field]" /> 
                                        </template>
                                    </Column> -->

                                    <Column field="margin" :header="$t('dealNote.margin')" style="width: 150px;"> 
                                        <template #body="{ data, field }">
                                            <span>{{ utils.formatDecimal(data[field], 2, "it-IT") }}</span>                                  
                                        </template>                           
                                        <template #editor="{ data, field }">
                                            <InputNumber class="w-full" v-model="data[field]" :minFractionDigits="0" :maxFractionDigits="2" />
                                        </template>
                                    </Column>

                                    <Column field="buyerSeller" :header="$t('dealNote.buyerSeller')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                                        </template>
                                        <template #editor="{data}">
                                            <GenericCustomMasterDataAutocompleteV2 
                                                class="p-inputtext-sm w-full"
                                                v-model="data.idBuyerSeller"
                                                api="masterdata/company-combo" 
                                                name="masterdata-company-combo" 
                                                v-if="isVoyageEditable(data)" />    
                                                <span v-else>{{ data.buyerSeller }}</span>                            
                                        </template>
                                    </Column>

                                    <Column field="benchmark" :header="$t('dealNote.benchmark')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                                        </template>
                                        <template #editor="{ data, field }">
                                            <Textarea class="w-full" autoResize v-model="data[field]" />
                                        </template>
                                    </Column>

                                    <Column field="comment" :header="$t('dealNote.comment')" style="width: 300px;">
                                        <template #editor="{ data, field }">
                                            <Textarea class="w-full" autoResize v-model="data[field]" />
                                        </template>
                                    </Column>

                                    <template #groupheader="slotProps">
                                        <div class="flex align-items-center gap-2">
                                            <span>{{ slotProps.data.family }}</span>
                                        </div>
                                    </template>
                            </DataTable>
                        </div>
                    </div>
                </TabPanel>
                <TabPanel header="Other">
                    <div class="grid">
                        <div class="col-12" style="height: calc(75vh)" >
                            <DataTable showGridlines :value="dealNote.otherSheet" scrollable :responsiveLayout="'stack'" scrollHeight="flex" rowGroupMode="subheader" groupRowsBy="family" sortMode="single"
                                :sortOrder="1" editMode="row" size="small" v-model:editing-rows="editDataCrude" @row-edit-save="onCrudeRowEditSave" 
                                v-model:filters="otherFilters" filterDisplay="row" dataKey="id" :rowClass="rowClass" >

                                    <Column frozen style="width: 180px" class="button-column" :exportable="false" :reorderableColumn="false">
                                        <template #body="slotProps">
                                            <Button v-tooltip="$t('dealNote.uploadDocument')" icon="fa-solid fa-upload" class="p-button-sm p-button-rounded p-button-outlined mr-1 mb-1" size="small" 
                                            @click="openUploadDialog(slotProps.data)" v-if="!uiPermissions('dealNoteUploadDocument').isHidden" />
                                            <Button v-tooltip="$t('dealNote.downloadDocument')" icon="fa-solid fa-download" class="p-button-sm p-button-rounded p-button-outlined mr-1 mb-1" size="small" @click="openDownloadDialog(slotProps.data)" />
                                            <Button v-tooltip="$t('dealNote.openLog')" icon="fa-solid fa-file-lines" class="p-button-sm p-button-rounded p-button-outlined mr-1 mb-1" size="small" @click="openLogDialog(slotProps.data)" />
                                            <Button v-tooltip="$t('dealNote.clone')" icon="fa-solid fa-code-merge" class="p-button-sm p-button-rounded p-button-outlined mr-1 mb-1" size="small" 
                                            @click="cloneDeal(slotProps.data)" v-if="!uiPermissions('dealNoteCloneButton').isHidden" />
                                            <span class="warning" v-if="slotProps.data.isUpdateBlocked" v-tooltip="$t('dealNote.updateBlocked')">
                                                <i class="fas fa-lock" style='font-size:10px; color:black;' />
                                            </span>
                                        </template>
                                    </Column>
                                    <Column frozen :rowEditor="true" style="width: 150px;" v-if="!uiPermissions('dealNoteEditButton').isHidden" />

                                    <Column field="family" :header="$t('dealNote.family')">
                                        <template #body="{ data, field }">
                                            <span>
                                                {{ data[field] }}
                                                <Tag severity="warning" value="Modified" v-if="data[field + '_dirty']" />
                                            </span>
                                        </template>
                                    </Column>
                                                            
                                    <!---<Column field="family" :header="$t('dealNote.family')" style="width: 150px;"></Column> -->

                                    <Column field="dealDate" :header="$t('dealNote.dealDate')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{data[field] != null ? utils.formatDate(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                                        </template>
                                        <template #editor="{ data, field }">   
                                            <Calendar 
                                                class="w-full" 
                                                v-model="data[field]" 
                                                dateFormat="dd/mm/yy" 
                                                placeholder="dd/mm/yyyy" v-if="isVoyageEditable(data)"/>                                 
                                            <span v-else>{{data[field] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                                        </template>                       
                                    </Column>

                                    <Column field="voyageNumber" :header="$t('dealNote.voyageNumber')" style="width: 150px;"> 
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search"/>
                                        </template>                           
                                    </Column>

                                    <Column field="registryProduct" :header="$t('dealNote.product')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                                        </template>
                                        <template #body="{ data, field }">
                                            <span>{{ data[field] }}</span>
                                            <span class="warning" v-if="checkStatus(data) && data[field] != data.plannedRegistryProduct" v-tooltip="'Planned: ' + data.plannedRegistryProduct">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                        <template #editor="{data}">
                                            <GenericCustomMasterDataAutocompleteV2
                                            class="p-inputtext-sm w-full"
                                            v-model="data.idRegistryProduct"
                                            api="masterdata/product-combo" 
                                            name="masterdata-product-combo" 
                                            v-if="isVoyageEditable(data)"/> 
                                            <span v-else>{{ data.registryProduct }}</span>                                    
                                        </template>
                                    </Column>

                                    <Column field="grade" :header="$t('dealNote.grade')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                                        </template>
                                        <template #editor="{ data, field }">
                                            <InputText v-model="data[field]" class="w-full" />
                                            <!-- <GenericCustomMasterDataAutocompleteV2
                                                class="w-full"
                                                :name="`registry-deal-note-column-combo?family=${data.family}&columnType=${field}`"
                                                v-model="data[field]"
                                                :api="`masterdata/registry-deal-note-column-combo?family=${data.family}&columnType=${field}`"/>                             -->
                                        </template>
                                    </Column>

                                    <Column field="isabCode" :header="$t('dealNote.isabCode')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                                        </template>
                                    </Column>

                                    <Column field="terminal" :header="$t('dealNote.terminal')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <Dropdown v-model="filterModel.value" :options="terminalArray" 
                                            @change="filterCallback()" class="w-full" placeholder="Terminal" />
                                        </template>
                                        <template #body="{ data, field }">
                                            <span>{{ data[field] }}</span>
                                            <span class="warning" v-if="data[field] != data.plannedTerminal" v-tooltip="'Planned: ' + data.plannedTerminal">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                        <template #editor="{data}">
                                            <GenericCustomMasterDataAutocompleteV2 
                                                class="p-inputtext-sm w-full"
                                                v-model="data.idRegistryPlant"
                                                api="masterdata/registry-plant-combo" 
                                                name="masterdata-registry-plant-combo" 
                                                v-if="isVoyageEditable(data)" />    
                                                <span v-else>{{ data.terminal }}</span>                                  
                                        </template>
                                    </Column>

                                    <Column field="registryVessel" :header="$t('dealNote.registryVessel')" style="width: 150px;">                                                             
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search"/>
                                        </template>
                                    </Column>

                                    <Column class="status" field="status" :header="$t('dealNote.status')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <Dropdown v-model="filterModel.value" :options="statusArray" 
                                            @change="filterCallback()" class="w-full" placeholder="Status" />
                                        </template>
                                        <template #editor="{ data, field }">
                                            <Dropdown v-model="data[field]" :placeholder="data[field]"
                                            :options="statusArray" checkmark :highlightOnSelect="false" class="w-full"/>                           
                                        </template>  
                                        <template #body="slotProps">
                                            <Tag style="font-size: 10px" :value="slotProps.data.status" :severity="getStatusLabel(slotProps.data.status)" />
                                            <span class="warning" v-if="vesselSummaryCancelled(slotProps.data)" v-tooltip="'Planned: ' + slotProps.data.vesselSummaryStatus">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                    </Column>                            

                                    <Column field="laycanStartDate" :header="$t('dealNote.laycanStartDate')">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <Calendar                                                                        
                                                class="w-full" 
                                                showTime hourFormat="24"
                                                v-model="filterModel.value" 
                                                @keydown.enter="filterCallback()"  
                                                dateFormat="dd/mm/yy" 
                                                placeholder="dd/mm/yyyy"/> 
                                        </template>
                                        <template #body="{ data, field }">
                                            <span>{{data[field] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                                            <span class="warning" v-if="checkStatus(data) && data[field].getTime() != data.plannedLaycanStartDate.getTime()" v-tooltip="'Planned: ' + utils.formatDateTime(utils.dateToCurrentTimeZone(data.plannedLaycanStartDate))">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                        <template #editor="{ data, field }">   
                                            <Calendar 
                                                v-if="isVoyageEditable(data)"
                                                class="w-full" 
                                                showTime hourFormat="24"
                                                v-model="data[field]" 
                                                dateFormat="dd/mm/yy" 
                                                placeholder="dd/mm/yyyy"/> 
                                            <span v-else>{{data[field] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data[field])) : null}}</span>                                                                  
                                        </template>
                                    </Column>
                                    <Column field="laycanEndDate" :header="$t('dealNote.laycanEndDate')">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <Calendar                                                                        
                                                class="w-full" 
                                                showTime hourFormat="24"
                                                v-model="filterModel.value" 
                                                @keydown.enter="filterCallback()"  
                                                dateFormat="dd/mm/yy" 
                                                placeholder="dd/mm/yyyy"/> 
                                        </template>
                                        <template #body="{ data, field }">
                                            <span>{{data[field] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                                            <span class="warning" v-if="checkStatus(data) && data[field].getTime() != data.plannedLaycanEndDate.getTime()" v-tooltip="'Planned: ' + utils.formatDateTime(utils.dateToCurrentTimeZone(data.plannedLaycanEndDate))">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                        <template #editor="{ data, field }">  
                                            <Calendar 
                                                v-if="isVoyageEditable(data)"
                                                class="w-full" 
                                                showTime hourFormat="24"
                                                v-model="data[field]" 
                                                dateFormat="dd/mm/yy" 
                                                placeholder="dd/mm/yyyy"/>  
                                            <span v-else>{{data[field] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data[field])) : null}}</span>                                                                    
                                        </template>
                                    </Column>

                                    <Column field="quantity" :header="$t('dealNote.quantity')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ utils.formatInteger(data[field]) }}</span>
                                            <span class="warning" v-if="checkStatus(data) && data[field] != data.plannedQuantity" v-tooltip="'Planned: ' + utils.formatInteger(data.plannedQuantity)">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                        <template #editor="{ data, field }">
                                            <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="0" v-if="isVoyageEditable(data)" />
                                            <span v-else>{{ utils.formatInteger(data[field]) }}</span>
                                        </template>
                                    </Column>

                                    <Column field="minimumQuantity" :header="$t('dealNote.minimumQuantity')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ utils.formatInteger(data[field]) }}</span>
                                            <span class="warning" v-if="checkStatus(data) && data[field] != data.plannedMinimumQuantity" v-tooltip="'Planned: ' + utils.formatInteger(data.plannedMinimumQuantity)">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                        <template #editor="{ data, field }">
                                            <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="0" v-if="isVoyageEditable(data)" />
                                            <span v-else>{{ utils.formatInteger(data[field]) }}</span>
                                        </template>
                                    </Column>

                                    <Column field="maximumQuantity" :header="$t('dealNote.maximumQuantity')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ utils.formatInteger(data[field]) }}</span>
                                            <span class="warning" v-if="checkStatus(data) && data[field] != data.plannedMaximumQuantity" v-tooltip="'Planned: ' + utils.formatInteger(data.plannedMaximumQuantity)">
                                                <i class="fas fa-exclamation-triangle" style='font-size:15px; color:red;' />
                                            </span>
                                        </template>
                                        <template #editor="{ data, field }">
                                            <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="0" v-if="isVoyageEditable(data)" />
                                            <span v-else>{{ utils.formatInteger(data[field]) }}</span>
                                        </template>
                                    </Column>

                                    <Column field="quantityUoM" :header="$t('dealNote.uom')" style="width: 150px;">
                                        <template #editor="{ data, field }">
                                            <InputText class="w-full" v-model="data[field]" v-if="isVoyageEditable(data)"/>
                                            <span v-else>{{ data[field] }}</span>
                                        </template>
                                    </Column>

                                    <Column field="quality" :header="$t('dealNote.quality')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                                        </template>
                                        <template #editor="{ data, field }">
                                            <InputText v-model="data[field]" class="w-full" />
                                            <!--<GenericCustomMasterDataAutocompleteV2
                                                class="w-full"
                                                :name="`registry-deal-note-column-combo?family=${data.family}&columnType=${field}`"
                                                v-model="data[field]"
                                                :api="`masterdata/registry-deal-note-column-combo?family=${data.family}&columnType=${field}`"/>-->                            
                                        </template>
                                    </Column>

                                    <Column field="econs" :header="$t('dealNote.econs')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                                        </template>
                                        <template #editor="{ data, field }">
                                            <Textarea class="w-full" autoResize v-model="data[field]" />
                                        </template>
                                    </Column>

                                    <Column field="marker" :header="$t('dealNote.marker')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                                        </template>
                                        <template #editor="{ data, field }">
                                            <GenericCustomMasterDataAutocompleteV2
                                                class="w-full"
                                                name= "true-up/price-formula-combo"
                                                v-model="data[field]"
                                                api="true-up/price-formula-combo"/>                            
                                        </template>
                                    </Column>

                                    <Column field="priceWindow" :header="$t('dealNote.priceWindow')" style="min-width: 220px">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search"/>
                                        </template>
                                        <template #editor="{ data }">
                                            <div class="grid">
                                                <div class="col-10">
                                                    <label>{{ $t("dealNote.labelPriceWindow") }}</label>
                                                    <GenericCustomMasterDataAutocompleteV2
                                                        class="w-full"
                                                        name= "planning/deal-note-price-window-combo"
                                                        v-model="data.idRegistryPriceWindowType"
                                                        :changeFn="onUpdatePriceWindow"
                                                        :refLabel="data"
                                                        :api="`masterdata/price-window-type-combo`"/> 
                                                        
                                                </div>

                                                <div class="col-12" v-if="data.idRegistryPriceWindowType == 1">
                                                    <label>{{ $t("dealNote.labelDatePriceWindow") }}</label>
                                                    <Calendar
                                                        class="p-inputtext-sm w-full"
                                                        placeholder="__/__/____"
                                                        v-model="data.monthDate"
                                                        dateFormat="mm/yy" :showTime="false"
                                                        :showIcon="true" :showButtonBar="true" :yearNavigator="true" 
                                                        view="month" />
                                                </div>
                                                
                                                <div class="col-12" v-else-if="data.idRegistryPriceWindowType == 5">
                                                    <div class="grid">
                                                        <div class="col-12 lg:col-6 w-full">
                                                            <label>{{ $t("from") }}</label>
                                                            <Calendar
                                                                class="p-inputtext-sm w-full"
                                                                placeholder="__/__/____"
                                                                v-model="data.dateFrom"
                                                                dateFormat="dd/mm/yy" :showTime="false"
                                                                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                                                        </div>
                                                        <div class="col-12 lg:col-6 w-full">
                                                            <label>{{ $t("to") }}</label>
                                                            <Calendar
                                                                class="p-inputtext-sm w-full"
                                                                placeholder="__/__/____"
                                                                v-model="data.dateTo"
                                                                dateFormat="dd/mm/yy" :showTime="false"
                                                                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                                                        </div>
                                                    </div>                                                
                                                </div>

                                                <div class="col-12" v-else-if="data.idRegistryPriceWindowType">
                                                    <div class="grid">
                                                        <div class="col-12 lg:col-8">
                                                            <label>{{ $t("from") }}</label>
                                                            <Calendar
                                                                class="p-inputtext-sm w-full"
                                                                placeholder="__/__/____"
                                                                v-model="data.dateFrom"
                                                                dateFormat="dd/mm/yy" :showTime="false"
                                                                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                                                        </div>

                                                        <div class="col-12 lg:col-4">
                                                            <label>{{ $t("Include") }}</label>
                                                            <Checkbox class="my-1 w-full" v-model="data.isReferenceDateIncluded" :binary="true" /> 
                                                        </div>                                                          
                                                    </div>                                                                                                                                            
                                                </div>                                           
                                            </div>
                                        </template>
                                        <template #body="{ data, field }">
                                            <span>{{ data[field] }}</span>                                              
                                            <span v-if="data.idRegistryPriceWindowType != 1 && data.idRegistryPriceWindowType != 5">&nbsp; {{ data.dateFrom != null ? utils.formatDate(data.dateFrom) : null }}</span>                                                                         
                                        </template> 
                                    </Column>

                                    <Column field="premiumBase" :header="$t('dealNote.premiumBase')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ utils.formatDecimal(data[field], 3, "it-IT") }}</span>                                  
                                        </template>
                                        <template #editor="{ data, field }">
                                            <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="3" />
                                        </template>
                                    </Column>

                                    <Column field="qualityPremium" :header="$t('dealNote.qualityPremium')" style="width: 150px;">
                                        <template #body="{ data, field }">
                                            <span>{{ utils.formatDecimal(data[field], 3, "it-IT") }}</span>                                  
                                        </template>
                                        <template #editor="{ data, field }">
                                            <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="3" />
                                        </template>
                                    </Column>

                                <!-- <Column field="dfl" :header="$t('dealNote.dfl')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                                        </template>
                                        <template #editor="{ data, field }">
                                            <InputText class="w-full" v-model="data[field]" />
                                        </template>
                                    </Column> -->

                                    <Column field="margin" :header="$t('dealNote.margin')" style="width: 150px;">     
                                        <template #body="{ data, field }">
                                            <span>{{ utils.formatDecimal(data[field], 2, "it-IT") }}</span>                                  
                                        </template>                         
                                        <template #editor="{ data, field }">
                                            <InputNumber class="w-full" v-model="data[field]" :minFractionDigits="0" :maxFractionDigits="2" />
                                        </template>
                                    </Column>

                                    <Column field="buyerSeller" :header="$t('dealNote.buyerSeller')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                                        </template>
                                        <template #editor="{data}">
                                            <GenericCustomMasterDataAutocompleteV2 
                                                class="p-inputtext-sm w-full"
                                                v-model="data.idBuyerSeller"
                                                api="masterdata/company-combo" 
                                                name="masterdata-company-combo" 
                                                v-if="isVoyageEditable(data)" />    
                                                <span v-else>{{ data.buyerSeller }}</span>                            
                                        </template>
                                    </Column>

                                    <Column field="benchmark" :header="$t('dealNote.benchmark')" style="width: 150px;">
                                        <template #filter="{ filterModel, filterCallback }">
                                            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search" />
                                        </template>
                                        <template #editor="{ data, field }">
                                            <Textarea class="w-full" autoResize v-model="data[field]" />
                                        </template>
                                    </Column>

                                    <Column field="comment" :header="$t('dealNote.comment')" style="width: 300px;">
                                        <template #editor="{ data, field }">
                                            <Textarea class="w-full" autoResize v-model="data[field]" />
                                        </template>
                                    </Column>

                                    <template #groupheader="slotProps">
                                        <div class="flex align-items-center gap-2">
                                            <span>{{ slotProps.data.family }}</span>
                                        </div>
                                    </template>
                            </DataTable>
                        </div>
                    </div>
                </TabPanel>
            </TabView>            
        </div>
    </main>
</template>

<style>
    .p-rowgroup-header{
        background-color: gray !important;
        color: white !important;
    }

    .bg-done {
        background-color: #87d37c !important;
    }
    .bg-firm {
        background-color: #f9bf3b !important;
    }
    .bg-deleted{
        background-color: #c0392b !important;
        color: white !important;
    }
    .warning{
        margin-left: 15px
    }
    .p-invalid-priceWindow{
        border-color: red;
    }
    .p-invalid-priceWindowMonth{
        border-color: red;
    }




    thead.p-datatable-thead{
        z-index: 2 !important;
    }

    tr.p-rowgroup-header{
        z-index: 2 !important;
    }

    td.p-frozen-column{
        z-index: 1 !important;

    }
</style>